(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = require("regenerator-runtime");

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/babel-runtime/regenerator/index.js","/../node_modules/babel-runtime/regenerator")
},{"buffer":3,"pBGvAp":5,"regenerator-runtime":6}],2:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/base64-js/lib/b64.js","/../node_modules/base64-js/lib")
},{"buffer":3,"pBGvAp":5}],3:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = Buffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192

/**
 * If `Buffer._useTypedArrays`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (compatible down to IE6)
 */
Buffer._useTypedArrays = (function () {
  // Detect if browser supports Typed Arrays. Supported browsers are IE 10+, Firefox 4+,
  // Chrome 7+, Safari 5.1+, Opera 11.6+, iOS 4.2+. If the browser does not support adding
  // properties to `Uint8Array` instances, then that's the same as no `Uint8Array` support
  // because we need to be able to add all the node Buffer API methods. This is an issue
  // in Firefox 4-29. Now fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=695438
  try {
    var buf = new ArrayBuffer(0)
    var arr = new Uint8Array(buf)
    arr.foo = function () { return 42 }
    return 42 === arr.foo() &&
        typeof arr.subarray === 'function' // Chrome 9-10 lack `subarray`
  } catch (e) {
    return false
  }
})()

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (subject, encoding, noZero) {
  if (!(this instanceof Buffer))
    return new Buffer(subject, encoding, noZero)

  var type = typeof subject

  // Workaround: node's base64 implementation allows for non-padded strings
  // while base64-js does not.
  if (encoding === 'base64' && type === 'string') {
    subject = stringtrim(subject)
    while (subject.length % 4 !== 0) {
      subject = subject + '='
    }
  }

  // Find the length
  var length
  if (type === 'number')
    length = coerce(subject)
  else if (type === 'string')
    length = Buffer.byteLength(subject, encoding)
  else if (type === 'object')
    length = coerce(subject.length) // assume that object is array-like
  else
    throw new Error('First argument needs to be a number, array or string.')

  var buf
  if (Buffer._useTypedArrays) {
    // Preferred: Return an augmented `Uint8Array` instance for best performance
    buf = Buffer._augment(new Uint8Array(length))
  } else {
    // Fallback: Return THIS instance of Buffer (created by `new`)
    buf = this
    buf.length = length
    buf._isBuffer = true
  }

  var i
  if (Buffer._useTypedArrays && typeof subject.byteLength === 'number') {
    // Speed optimization -- use set if we're copying from a typed array
    buf._set(subject)
  } else if (isArrayish(subject)) {
    // Treat array-ish objects as a byte array
    for (i = 0; i < length; i++) {
      if (Buffer.isBuffer(subject))
        buf[i] = subject.readUInt8(i)
      else
        buf[i] = subject[i]
    }
  } else if (type === 'string') {
    buf.write(subject, 0, encoding)
  } else if (type === 'number' && !Buffer._useTypedArrays && !noZero) {
    for (i = 0; i < length; i++) {
      buf[i] = 0
    }
  }

  return buf
}

// STATIC METHODS
// ==============

Buffer.isEncoding = function (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.isBuffer = function (b) {
  return !!(b !== null && b !== undefined && b._isBuffer)
}

Buffer.byteLength = function (str, encoding) {
  var ret
  str = str + ''
  switch (encoding || 'utf8') {
    case 'hex':
      ret = str.length / 2
      break
    case 'utf8':
    case 'utf-8':
      ret = utf8ToBytes(str).length
      break
    case 'ascii':
    case 'binary':
    case 'raw':
      ret = str.length
      break
    case 'base64':
      ret = base64ToBytes(str).length
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = str.length * 2
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.concat = function (list, totalLength) {
  assert(isArray(list), 'Usage: Buffer.concat(list, [totalLength])\n' +
      'list should be an Array.')

  if (list.length === 0) {
    return new Buffer(0)
  } else if (list.length === 1) {
    return list[0]
  }

  var i
  if (typeof totalLength !== 'number') {
    totalLength = 0
    for (i = 0; i < list.length; i++) {
      totalLength += list[i].length
    }
  }

  var buf = new Buffer(totalLength)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

// BUFFER INSTANCE METHODS
// =======================

function _hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  assert(strLen % 2 === 0, 'Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var byte = parseInt(string.substr(i * 2, 2), 16)
    assert(!isNaN(byte), 'Invalid hex string')
    buf[offset + i] = byte
  }
  Buffer._charsWritten = i * 2
  return i
}

function _utf8Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf8ToBytes(string), buf, offset, length)
  return charsWritten
}

function _asciiWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(asciiToBytes(string), buf, offset, length)
  return charsWritten
}

function _binaryWrite (buf, string, offset, length) {
  return _asciiWrite(buf, string, offset, length)
}

function _base64Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(base64ToBytes(string), buf, offset, length)
  return charsWritten
}

function _utf16leWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf16leToBytes(string), buf, offset, length)
  return charsWritten
}

Buffer.prototype.write = function (string, offset, length, encoding) {
  // Support both (string, offset, length, encoding)
  // and the legacy (string, encoding, offset, length)
  if (isFinite(offset)) {
    if (!isFinite(length)) {
      encoding = length
      length = undefined
    }
  } else {  // legacy
    var swap = encoding
    encoding = offset
    offset = length
    length = swap
  }

  offset = Number(offset) || 0
  var remaining = this.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }
  encoding = String(encoding || 'utf8').toLowerCase()

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexWrite(this, string, offset, length)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Write(this, string, offset, length)
      break
    case 'ascii':
      ret = _asciiWrite(this, string, offset, length)
      break
    case 'binary':
      ret = _binaryWrite(this, string, offset, length)
      break
    case 'base64':
      ret = _base64Write(this, string, offset, length)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leWrite(this, string, offset, length)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toString = function (encoding, start, end) {
  var self = this

  encoding = String(encoding || 'utf8').toLowerCase()
  start = Number(start) || 0
  end = (end !== undefined)
    ? Number(end)
    : end = self.length

  // Fastpath empty strings
  if (end === start)
    return ''

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexSlice(self, start, end)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Slice(self, start, end)
      break
    case 'ascii':
      ret = _asciiSlice(self, start, end)
      break
    case 'binary':
      ret = _binarySlice(self, start, end)
      break
    case 'base64':
      ret = _base64Slice(self, start, end)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leSlice(self, start, end)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toJSON = function () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function (target, target_start, start, end) {
  var source = this

  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (!target_start) target_start = 0

  // Copy 0 bytes; we're done
  if (end === start) return
  if (target.length === 0 || source.length === 0) return

  // Fatal error conditions
  assert(end >= start, 'sourceEnd < sourceStart')
  assert(target_start >= 0 && target_start < target.length,
      'targetStart out of bounds')
  assert(start >= 0 && start < source.length, 'sourceStart out of bounds')
  assert(end >= 0 && end <= source.length, 'sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length)
    end = this.length
  if (target.length - target_start < end - start)
    end = target.length - target_start + start

  var len = end - start

  if (len < 100 || !Buffer._useTypedArrays) {
    for (var i = 0; i < len; i++)
      target[i + target_start] = this[i + start]
  } else {
    target._set(this.subarray(start, start + len), target_start)
  }
}

function _base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function _utf8Slice (buf, start, end) {
  var res = ''
  var tmp = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    if (buf[i] <= 0x7F) {
      res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i])
      tmp = ''
    } else {
      tmp += '%' + buf[i].toString(16)
    }
  }

  return res + decodeUtf8Char(tmp)
}

function _asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++)
    ret += String.fromCharCode(buf[i])
  return ret
}

function _binarySlice (buf, start, end) {
  return _asciiSlice(buf, start, end)
}

function _hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function _utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i+1] * 256)
  }
  return res
}

Buffer.prototype.slice = function (start, end) {
  var len = this.length
  start = clamp(start, len, 0)
  end = clamp(end, len, len)

  if (Buffer._useTypedArrays) {
    return Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    var newBuf = new Buffer(sliceLen, undefined, true)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
    return newBuf
  }
}

// `get` will be removed in Node 0.13+
Buffer.prototype.get = function (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` will be removed in Node 0.13+
Buffer.prototype.set = function (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

Buffer.prototype.readUInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  return this[offset]
}

function _readUInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    val = buf[offset]
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
  } else {
    val = buf[offset] << 8
    if (offset + 1 < len)
      val |= buf[offset + 1]
  }
  return val
}

Buffer.prototype.readUInt16LE = function (offset, noAssert) {
  return _readUInt16(this, offset, true, noAssert)
}

Buffer.prototype.readUInt16BE = function (offset, noAssert) {
  return _readUInt16(this, offset, false, noAssert)
}

function _readUInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    if (offset + 2 < len)
      val = buf[offset + 2] << 16
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
    val |= buf[offset]
    if (offset + 3 < len)
      val = val + (buf[offset + 3] << 24 >>> 0)
  } else {
    if (offset + 1 < len)
      val = buf[offset + 1] << 16
    if (offset + 2 < len)
      val |= buf[offset + 2] << 8
    if (offset + 3 < len)
      val |= buf[offset + 3]
    val = val + (buf[offset] << 24 >>> 0)
  }
  return val
}

Buffer.prototype.readUInt32LE = function (offset, noAssert) {
  return _readUInt32(this, offset, true, noAssert)
}

Buffer.prototype.readUInt32BE = function (offset, noAssert) {
  return _readUInt32(this, offset, false, noAssert)
}

Buffer.prototype.readInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null,
        'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  var neg = this[offset] & 0x80
  if (neg)
    return (0xff - this[offset] + 1) * -1
  else
    return this[offset]
}

function _readInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt16(buf, offset, littleEndian, true)
  var neg = val & 0x8000
  if (neg)
    return (0xffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt16LE = function (offset, noAssert) {
  return _readInt16(this, offset, true, noAssert)
}

Buffer.prototype.readInt16BE = function (offset, noAssert) {
  return _readInt16(this, offset, false, noAssert)
}

function _readInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt32(buf, offset, littleEndian, true)
  var neg = val & 0x80000000
  if (neg)
    return (0xffffffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt32LE = function (offset, noAssert) {
  return _readInt32(this, offset, true, noAssert)
}

Buffer.prototype.readInt32BE = function (offset, noAssert) {
  return _readInt32(this, offset, false, noAssert)
}

function _readFloat (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 23, 4)
}

Buffer.prototype.readFloatLE = function (offset, noAssert) {
  return _readFloat(this, offset, true, noAssert)
}

Buffer.prototype.readFloatBE = function (offset, noAssert) {
  return _readFloat(this, offset, false, noAssert)
}

function _readDouble (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 7 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 52, 8)
}

Buffer.prototype.readDoubleLE = function (offset, noAssert) {
  return _readDouble(this, offset, true, noAssert)
}

Buffer.prototype.readDoubleBE = function (offset, noAssert) {
  return _readDouble(this, offset, false, noAssert)
}

Buffer.prototype.writeUInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'trying to write beyond buffer length')
    verifuint(value, 0xff)
  }

  if (offset >= this.length) return

  this[offset] = value
}

function _writeUInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 2); i < j; i++) {
    buf[offset + i] =
        (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
            (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt16BE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, false, noAssert)
}

function _writeUInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffffffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 4); i < j; i++) {
    buf[offset + i] =
        (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt32BE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, false, noAssert)
}

Buffer.prototype.writeInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7f, -0x80)
  }

  if (offset >= this.length)
    return

  if (value >= 0)
    this.writeUInt8(value, offset, noAssert)
  else
    this.writeUInt8(0xff + value + 1, offset, noAssert)
}

function _writeInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fff, -0x8000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt16(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt16(buf, 0xffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt16LE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt16BE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, false, noAssert)
}

function _writeInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fffffff, -0x80000000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt32(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt32(buf, 0xffffffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt32LE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt32BE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, false, noAssert)
}

function _writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifIEEE754(value, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 23, 4)
}

Buffer.prototype.writeFloatLE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, false, noAssert)
}

function _writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 7 < buf.length,
        'Trying to write beyond buffer length')
    verifIEEE754(value, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 52, 8)
}

Buffer.prototype.writeDoubleLE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, false, noAssert)
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (typeof value === 'string') {
    value = value.charCodeAt(0)
  }

  assert(typeof value === 'number' && !isNaN(value), 'value is not a number')
  assert(end >= start, 'end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  assert(start >= 0 && start < this.length, 'start out of bounds')
  assert(end >= 0 && end <= this.length, 'end out of bounds')

  for (var i = start; i < end; i++) {
    this[i] = value
  }
}

Buffer.prototype.inspect = function () {
  var out = []
  var len = this.length
  for (var i = 0; i < len; i++) {
    out[i] = toHex(this[i])
    if (i === exports.INSPECT_MAX_BYTES) {
      out[i + 1] = '...'
      break
    }
  }
  return '<Buffer ' + out.join(' ') + '>'
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer._useTypedArrays) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1)
        buf[i] = this[i]
      return buf.buffer
    }
  } else {
    throw new Error('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function (arr) {
  arr._isBuffer = true

  // save reference to original Uint8Array get/set methods before overwriting
  arr._get = arr.get
  arr._set = arr.set

  // deprecated, will be removed in node 0.13+
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

// slice(start, end)
function clamp (index, len, defaultValue) {
  if (typeof index !== 'number') return defaultValue
  index = ~~index;  // Coerce to integer.
  if (index >= len) return len
  if (index >= 0) return index
  index += len
  if (index >= 0) return index
  return 0
}

function coerce (length) {
  // Coerce length to a number (possibly NaN), round up
  // in case it's fractional (e.g. 123.456) then do a
  // double negate to coerce a NaN to 0. Easy, right?
  length = ~~Math.ceil(+length)
  return length < 0 ? 0 : length
}

function isArray (subject) {
  return (Array.isArray || function (subject) {
    return Object.prototype.toString.call(subject) === '[object Array]'
  })(subject)
}

function isArrayish (subject) {
  return isArray(subject) || Buffer.isBuffer(subject) ||
      subject && typeof subject === 'object' &&
      typeof subject.length === 'number'
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    var b = str.charCodeAt(i)
    if (b <= 0x7F)
      byteArray.push(str.charCodeAt(i))
    else {
      var start = i
      if (b >= 0xD800 && b <= 0xDFFF) i++
      var h = encodeURIComponent(str.slice(start, i+1)).substr(1).split('%')
      for (var j = 0; j < h.length; j++)
        byteArray.push(parseInt(h[j], 16))
    }
  }
  return byteArray
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(str)
}

function blitBuffer (src, dst, offset, length) {
  var pos
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length))
      break
    dst[i + offset] = src[i]
  }
  return i
}

function decodeUtf8Char (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    return String.fromCharCode(0xFFFD) // UTF 8 invalid char
  }
}

/*
 * We have to make sure that the value is a valid integer. This means that it
 * is non-negative. It has no fractional component and that it does not
 * exceed the maximum allowed value.
 */
function verifuint (value, max) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value >= 0, 'specified a negative value for writing an unsigned value')
  assert(value <= max, 'value is larger than maximum value for type')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifsint (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifIEEE754 (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
}

function assert (test, message) {
  if (!test) throw new Error(message || 'Failed assertion')
}

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/buffer/index.js","/../node_modules/buffer")
},{"base64-js":2,"buffer":3,"ieee754":4,"pBGvAp":5}],4:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/ieee754/index.js","/../node_modules/ieee754")
},{"buffer":3,"pBGvAp":5}],5:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/process/browser.js","/../node_modules/process")
},{"buffer":3,"pBGvAp":5}],6:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/regenerator-runtime/runtime-module.js","/../node_modules/regenerator-runtime")
},{"./runtime":7,"buffer":3,"pBGvAp":5}],7:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../node_modules/regenerator-runtime/runtime.js","/../node_modules/regenerator-runtime")
},{"buffer":3,"pBGvAp":5}],8:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ==============================
//  main.js
//  Main file for javascript consolidation. Do not write any javascript in this
//  file! Only include other modules as required.
//  Author: Diff - Foxpod
//  Please review practices documentation before contributing.
// ==============================

// ------------------------------
// MODULES
// ------------------------------
/**
 * UTILITIES LIBRARY
 *
 * @description General global JavaScript utility functions.
 * @namespace utils
 */

(function (theme) {

	/**
  * Class of general JavaScript utilities.
  */
	var Utilities = function () {
		function Utilities() {
			_classCallCheck(this, Utilities);

			// Initialize the handleize and toMoney functions
			this._handleize();
		}

		/**
   * Initializes the handleize function on the String object.
   * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
   *
   * @private
   * @memberof Utilities
   */


		_createClass(Utilities, [{
			key: '_handleize',
			value: function _handleize() {
				// UTF to ASCII map. Removes accents.
				var defaultDiacriticsRemovalap = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];

				// Generate the diacritics map to replace accented characters.
				var diacriticsMap = {};
				for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
					var letters = defaultDiacriticsRemovalap[i].letters.split("");

					for (var j = 0; j < letters.length; j++) {
						diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
					}
				}

				/**
     * Replaces accented characters with their non-accented counterparts.<br>
     * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
     *
     * @param {boolean} [remove=false] - Whether to remove unicode characters that are not mapped to a non-accented characters.
     * 	This includes all non-ascii characters.
     * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
     * @returns {string} String without accents.
     * @memberof Utilities
     * @example
     * // returns 'My accented string$.'
     * 'My áccentéd string$.'.noAccents();
     */
				String.prototype.noAccents = function (remove, replacement) {
					// x00-x7E is the ASCII character range
					var withoutAccents = this.replace(/[^\u0000-\u007E]/g, function (ch) {
						return diacriticsMap[ch] || ch;
					});

					replacement = replacement || '';

					if (remove) {
						withoutAccents = withoutAccents.replace(/[^\u0000-\u007E]/g, replacement);
					}

					return withoutAccents;
				};

				/**
     * Returns a "handleized" version of a string suitable for URLs and file names.<br>
     * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
     *
     * @param {string} [seperator=-] - The character to use as a separator.
     * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
     * @returns {string} The handleized string.
     * @memberof Utilities
     * @example
     * var myString = 'My áccentéd string$.';
     *
     * // returns 'my-accented-string'
     * myString.handleize();
     *
     * // returns 'my_accented_string##'
     * myString.handleize('_', '#');
     */
				String.prototype.handleize = function (separator, replacement) {
					var slug;
					separator = separator || '-';
					replacement = replacement || '';
					slug = this.noAccents(true, replacement).trim().replace(/[^a-z0-9\s-]/ig, replacement).replace(/\s/ig, separator);

					return slug.toLowerCase();
				};
			}

			/**
    * Curency formating function.
    *
    * @param {(number|string)} price - The price to format.
    * @param {object} options - The options for the currency formatter.
    * @param {boolean} [options.cents=false] - Wether or not the price is currently in cents.
    * @param {string} [options.locale=Shop locale or 'en-CA'] - Override the locale to format to.
    * @param {string} [options.currency=Shop currency or 'CAD'] - Override the currency to output.
    * @returns {(string|null)} The price formatted based on the locale and currency.
    * @memberof Utilities
    * @example
    * // Returns '$12.56'
    * theme.utils.toMoney(12.56)
    *
    * // Returns '12,56 $'
    * theme.utils.toMoney('12.56', { locale: 'fr-CA', currency: 'CAD' })
    *
    * // Returns '$12.56'
    * theme.utils.toMoney('1256', { cents: true })
    */

		}, {
			key: 'toMoney',
			value: function toMoney(price, options) {
				if (!price && price < 0) {
					console.error('Utilities.toMoney: Invalid price passed.', price);
					return null;
				}

				var price = new Number(price);
				var options = options || {};

				// Assign defaults if no options are passed.
				options.cents = options.cents || false;
				options.locale = options.locale || (theme.shop ? theme.shop.locale : null) || 'en-CA';
				options.currency = options.currency || (theme.shop ? theme.shop.currency : null) || 'CAD';

				// Convert to dollars if the amount passed is in cents
				if (options.cents) {
					price = price / 100;
				}

				return price.toLocaleString(options.locale, { style: 'currency', currency: options.currency });
			}
		}, {
			key: 'removeProtocol',


			/**
    * Removes the URL protocol.
    *
    * @param {string} path - The URL to strip out the protocol from.
    * @returns {(string|null)} The URL without protocol.
    * @memberof Utilities
    */
			value: function removeProtocol(path) {
				if (!path) {
					console.error('Utilities.removeProtocol: Invalid path passed.', path);
					return null;
				}

				return path.replace(/http(s)?:/, '');
			}

			/**
    * Adds a Shopify size attribute to an image URL.
    *
    * @param {string} src - The image source URL.
    * @param {string} size - The size parameters to fetch, following Shopify's img_url guidelines.
    * @returns {(string|null)} The updated URL.
    * @memberof Utilities
    * @example
    * theme.utils.getSizedImageUrl('cdn.shopify.com/some-image.jpg', '500x300_crop_center');
    */

		}, {
			key: 'getSizedImageUrl',
			value: function getSizedImageUrl(src, size) {
				if (!size) {
					console.error('Utilities.getSizedImageUrl: Invalid size passed.', size);
					return src;
				}

				if (size === 'master') {
					return this.removeProtocol(src);
				}

				var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

				if (match) {
					var prefix = src.split(match[0]);
					var suffix = match[0];

					return this.removeProtocol(prefix[0] + '_' + size + suffix);
				} else {
					console.error('Utilities.getSizedImageUrl: Invalid image URL passed.', src);
					return null;
				}
			}

			/**
    * Created an object from a parameter string.
    *
    * @param {string} object_string - The string to parse to an object.
    * @returns {object} The object created from the string.
    * @memberof Utilities
    * @example
    * // If called on a form that takes a name and email, could return { name: "Joe", email: "joe@diffagency.com" }
    * theme.utils.toObject($form.serialize());
    */

		}, {
			key: 'toObject',
			value: function toObject(object_string) {
				var parameters = {};
				var elements;

				if (!object_string) {
					return {};
				}

				// Decode the query string to get original characters
				object_string = decodeURIComponent(object_string);

				// Split into each element
				elements = object_string.split('&');

				elements.forEach(function (element) {
					var element = element.split('=');
					parameters[element[0]] = element[1] || null;
				});

				return parameters;
			}

			/**
    * Extracts the URL parameters into an object.
    *
    * @param {string} [url=window.location.href] - The URL to parse.
    * @returns {object} The query parameters object.
    * @memberof Utilities
    * @example
    * // Returns { name: "Joe", email: "joe@diffagency.com" }
    * theme.utils.getURLParams('https://example.com/?name%3DJoe%26email%3Djoe%40diffagency.com');
    */

		}, {
			key: 'getURLParams',
			value: function getURLParams(url) {
				var url = url || window.location.href;
				// Get the string after the '?' from the URL
				var query_string = url.split(/\?(.+)/)[1];

				if (!query_string) {
					return {};
				}

				return this.toObject(query_string);
			}
		}]);

		return Utilities;
	}();

	// Global export


	theme.utils = new Utilities();
})(window.theme = window.theme || {});
/**
 * CART LIBRARY
 *
 * @description Handles the Shopify cart interactions.
 * @namespace cart
 */

(function (theme, $) {

	/**
  * Class representing the cart.
  */
	var Cart = function () {

		/**
   * Creates an instance of Cart.
   *
   * @param {object} [cart] - A cart object to use. Passing this argument will avoid an AJAX call to the Shopify API.
   * @constructs Cart
   * @memberof Cart
   */
		function Cart(cart) {
			_classCallCheck(this, Cart);

			this.content = cart || {};

			// If no cart is passed, fetch it.
			if (!cart) {
				this.fetch();
			}
		}

		// ------------------------------
		//  Getters and Setters
		// ------------------------------

		/**
   * The cart object.<br><br>
   * @example
   * // Get the cart object
   * theme.cart.content
   *
   * @type {object}
   * @fires cart_set
   * @memberof Cart
   */


		_createClass(Cart, [{
			key: 'fetch',


			// ------------------------------
			//  Methods
			// ------------------------------

			/**
    * Queries the Shopify API to refresh the cart.<br>
    * Calling this function will update the cart object.
    *
    * @fires cart_fetch
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * theme.cart.fetch();
    */
			value: function fetch() {
				var _this = this;

				return $.ajax({
					url: '/cart.js',
					type: 'GET',
					dataType: 'json'
				}).done(function (cart) {
					_this.content = cart;

					/**
      * The cart has been fetched.
      * The event is attached to the document element.<br><br>
      *
      * @event cart_fetch
      * @property {object} cart - The cart object.
      * @memberof Cart
      * @example
      * $(document).on('cart_fetch', function(event, cart) {});
      */
					$(document).trigger('cart_fetch', _this.content);
				}).fail(function (resp) {
					console.error('Cart.fetch: Error getting the cart.', resp);
				});
			}

			/**
    * Adds an item to cart.
    *
    * @param {(object|number)} item - The item id or item object to add.
    * @param {number} item.id - The id of the variant to add.
    * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
    * @fires cart_add
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Adds 1 of item 1234567 to the cart.
    * theme.cart.add(1234567);
    */

		}, {
			key: 'add',
			value: function add(item) {
				var _this2 = this;

				if (!item) {
					console.error('Cart.add: No item was passed.');
					return false;
				}

				// Set up the object if only an id is passed.
				if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) != 'object') {
					item = {
						id: item
					};
				}

				// Default the quantity to 1 if none is passed.
				item.quantity = item.quantity || 1;

				return $.ajax({
					url: '/cart/add.js',
					data: item,
					type: 'POST',
					dataType: 'json'
				}).done(function (item) {
					// Refresh the cart
					_this2.fetch();

					/**
      * An item has been added to cart.
      * The event is attached to the document element.<br><br>
      *
      * @event cart_add
      * @property {object} item - The item added to cart.
      * @memberof Cart
      * @example
      * $(document).on('cart_add', function(event, item) {});
      */
					$(document).trigger('cart_add', item);
				}).fail(function (resp) {
					console.error('Cart.add: Error adding to the cart.', resp);
				});
			}

			/**
    * Updates an item in the cart.
    *
    * @param {(object|object[]|number|number[])} items - The item id, id array, item object or object array to update.
    * @param {number} items.id - The id of the variant to update.
    * @param {number} [items.quantity=1] - Quantity to add, defaults to 1.
    * @fires cart_update
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Updated item 1234567's quantity to 5
    * theme.cart.update({ id: 1234567, quantity: 5 });
    *
    * // Updated item 1234567's quantity to 5 and item 7654321's quantity to 1
    * theme.cart.update([{ id: 1234567, quantity: 5 }, 7654321]);
    */

		}, {
			key: 'update',
			value: function update(items) {
				var _this3 = this;

				if (!items) {
					console.error('Cart.update: No item was passed.');
					return false;
				}

				var data = {};

				/**
     * Internal function to convert items to the proper format for Shopify's update API call.
     *
     * @param {object} data - The data object to add the key/value pair to.
     * @param {(object|number)} item - The item id or item object to format.
     * @private
     */
				var _addUpdateItem = function _addUpdateItem(item) {
					// Set up the object if only an id is passed.
					if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
						if (!item.id) {
							console.error('Cart.update: No id was passed with the product object.');
							return false;
						}
						data[item.id] = item.quantity || item.quantity === 0 ? item.quantity : 1;
					} else {
						data[item] = 1;
					}
				};

				if (Array.isArray(items)) {
					items.forEach(function (item) {
						_addUpdateItem(item);
					});
				} else {
					_addUpdateItem(items);
				}

				// Don't make the AJAX call if the data is empty.
				if (Object.keys(data).length === 0) {
					return false;
				}

				$('.flyout__overlay').addClass('flyout__overlay--active');
				$('.flyout__loader').addClass('flyout__loader--active');

				return $.ajax({
					url: '/cart/update.js',
					data: { updates: data },
					type: 'POST',
					dataType: 'json'
				}).done(function (cart) {
					// Refresh the cart
					_this3.content = cart;
					$('#flyout .flyout__fail-msg').removeClass('flyout__fail-msg--active');
					$('#flyout .flyout__success-msg').addClass('flyout__success-msg--active');

					/**
      * An item in the cart has been updated.
      * The event is attached to the document element.<br><br>
      *
      * @event cart_update
      * @property {object} cart - The cart object.
      * @property {object} item - The item changed.
      * @memberof Cart
      * @example
      * $(document).on('cart_update', function(event, cart, item) {});
      */
					$(document).trigger('cart_update', [cart, items]);
				}).fail(function (resp) {
					$('#flyout .flyout__success-msg').removeClass('flyout__success-msg--active');
					$('#flyout .flyout__fail-msg').addClass('flyout__fail-msg--active');

					console.error('Cart.update: Error updating a cart item.', resp);
				}).always(function () {
					$('.flyout__overlay').removeClass('flyout__overlay--active');
					$('.flyout__loader').removeClass('flyout__loader--active');
				});
			}

			/**
    * Change an item in the cart.
    *
    * @param {(object|number)} item - The item id or item object to update.
    * @param {number} item.id - The id of the variant to update.
    * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
    * @fires cart_change
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Changes item 1234567's quantity to 2
    * theme.cart.update({ id: 1234567, quantity: 2 });
    */

		}, {
			key: 'change',
			value: function change(item) {
				var _this4 = this;

				if (!item) {
					console.error('Cart.change: No item was passed.');
					return false;
				}

				// Set up the object if only an id is passed.
				if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) != 'object') {
					item = {
						id: item
					};
				}

				// Default the quantity to 1 if none is passed.
				item.quantity = item.quantity || 1;

				return $.ajax({
					url: '/cart/change.js',
					data: item,
					type: 'POST',
					dataType: 'json'
				}).done(function (cart) {
					// Refresh the cart
					_this4.content = cart;

					/**
      * An item in the cart's quantity has been changed.
      * The event is attached to the document element.<br><br>
      *
      * @event cart_change
      * @property {object} cart - The cart object.
      * @property {object} item - The item changed.
      * @memberof Cart
      * @example
      * $(document).on('cart_change', function(event, cart, item) {});
      */
					$(document).trigger('cart_change', [cart, item]);
				}).fail(function (resp) {
					console.error('Cart.change: Error changing a cart quantity.', resp);
				});
			}

			/**
    * Updates an item in the cart.
    *
    * @param {(object|object[]|number|number[])} item - The item id, id array, item object or object array to remove.
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Removes item 1234567 from the cart
    * theme.cart.remove(1234567);
    */

		}, {
			key: 'remove',
			value: function remove(items) {
				if (!items) {
					console.error('Cart.remove: No item was passed.');
					return false;
				}

				// Create an array of items with quantity 0 and feed to the update function.
				var remove_items = [];

				if (Array.isArray(items)) {
					items.forEach(function (item) {
						remove_items.push({ id: (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? item.id : item, quantity: 0 });
					});
				} else {
					remove_items.push({ id: (typeof items === 'undefined' ? 'undefined' : _typeof(items)) === 'object' ? items.id : items, quantity: 0 });
				}

				return this.update(remove_items);
			}

			/**
    * Empty the cart.
    *
    * @fires cart_clear
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * theme.cart.clear();
    */

		}, {
			key: 'clear',
			value: function clear() {
				var _this5 = this;

				return $.ajax({
					url: '/cart/clear.js',
					type: 'POST',
					dataType: 'json'
				}).done(function (cart) {
					// Refresh the cart
					_this5.content = cart;

					/**
      * The cart has been cleared.
      * The event is attached to the document element.<br><br>
      *
      * @event cart_clear
      * @property {object} cart - The cart object.
      * @memberof Cart
      * @example
      * $(document).on('cart_clear', function(event, cart) {});
      */
					$(document).trigger('cart_clear', cart);
				}).fail(function (resp) {
					console.error('Cart.clear: Error clearing the cart.', resp);
				});
			}

			/**
    * Updates an attribute in the cart.
    *
    * @param {object} attributes - The attribute(s) to update.
    * @param {object} options - The options to pass
    * @param {boolean} [options.no_overwrite=false] - Option to skip setting attributes if they are already set.
    * @fires cart_attributeUpdate
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Update the language attribute to 'fr' and currency to CAD
    * theme.cart.updateAttributes({ langauge: 'fr', currency: 'CAD' });
    *
    * // Update the language attribute to 'fr' but don't overwrite if already set
    * theme.cart.updateAttributes({ langauge: 'fr' }, { no_overwrite: true });
    */

		}, {
			key: 'updateAttributes',
			value: function updateAttributes(attributes, options) {
				var _this6 = this;

				if (!attributes) {
					console.warn('Cart.updateAttribute: No attributes were passed.');
					return $.when();
				}

				var data = {};
				options = options || {};

				// If we don't overwrite, only add attributes that are not set in cart
				if (options.no_overwrite) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var key = _step.value;

							if (!this.content.attributes[key]) {
								data[key] = attributes[key];
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				} else {
					data = attributes;
				}

				// If data is empty, return empty promise
				if (!Object.keys(data).length) {
					return $.when();
				}

				// Patch for updating cart note
				data = { attributes: data };

				if ('note' in data.attributes) {
					data.note = data.attributes.note;
				}

				return $.ajax({
					url: '/cart/update.js',
					data: data,
					type: 'POST',
					dataType: 'json'
				}).done(function (cart) {
					// Refresh the cart
					_this6.content = cart;

					/**
      * An item in the cart has been updated.
      * The event is attached to the document element.<br><br>
      *
      * @event cart_attributeUpdate
      * @property {object} cart - The cart object.
      * @property {object} attributes - The attributes changed.
      * @memberof Cart
      * @example
      * $(document).on('cart_attributeUpdate', function(event, cart, attributes) {});
      */
					$(document).trigger('cart_update', [cart, data]);
				}).fail(function (resp) {
					console.error('Cart.attributeUpdate: Failed updating a cart attribute.', resp);
				});
			}
		}, {
			key: 'content',
			get: function get() {
				return this._object;
			},
			set: function set(cart) {
				// The Cart class uses a private variable to keep track of the cart content.
				this._object = cart || this._object;

				/**
     * The cart has been updated.
     * The event is attached to the document element.<br><br>
     *
     * @event cart_set
     * @property {object} cart - The cart object.
     * @memberof Cart
     * @example
     * $(document).on('cart_set', function(event, cart) {});
     */
				$(document).trigger('cart_set', this.content);
			}
		}]);

		return Cart;
	}();

	// Global export


	theme.cart = new Cart(theme.cart_json || null);
})(window.theme = window.theme || {}, jQuery);
/**
 * GEOGRAPHIC COORDINATES MODEL
 *
 * @description Facilitates access to geographic coordinates.
 * @namespace coordinates
 */
(function (theme) {
	var Coordinates = function () {
		function Coordinates(latitude, longitude) {
			_classCallCheck(this, Coordinates);

			this.latitude = latitude;
			this.longitude = longitude;
		}

		_createClass(Coordinates, [{
			key: 'getLatitude',
			value: function getLatitude() {
				return this.latitude;
			}
		}, {
			key: 'getLongitude',
			value: function getLongitude() {
				return this.longitude;
			}
		}, {
			key: 'getPosition',
			value: function getPosition() {
				return {
					latitude: this.latitude,
					longitude: this.longitude
				};
			}
		}, {
			key: 'getLatLng',
			value: function getLatLng() {
				return {
					lat: parseFloat(this.latitude),
					lng: parseFloat(this.longitude)
				};
			}
		}]);

		return Coordinates;
	}();

	Coordinates.prototype.toString = function () {
		return JSON.stringify(this.getPosition());
	};

	theme.Coordinates = Coordinates;
})(window.theme = window.theme || {});

/**
 * GEOLOCATION LIBRARY
 *
 * @description Gets the user's current location.
 * @namespace geolocation
 */

(function (theme, $) {
	var Geolocation = function () {
		_createClass(Geolocation, null, [{
			key: 'STORAGE_KEYS',
			get: function get() {
				return Object.freeze({
					user_location: 'user_location'
				});
			}
		}]);

		function Geolocation() {
			_classCallCheck(this, Geolocation);

			this._deferred = $.Deferred();
		}

		_createClass(Geolocation, [{
			key: '_locateUser',
			value: function _locateUser() {
				var _this7 = this;

				var location = sessionStorage.getItem('user_location');
				if (location) {
					return this._deferred.resolve(JSON.parse(location));
				}
				try {
					geoip2.city(function (response) {
						sessionStorage.setItem(Geolocation.STORAGE_KEYS.user_location, JSON.stringify(response));
						_this7._deferred.resolve(response);
					}, function (e) {
						console.warn('Geolocation._locateUser:', e.error);
						_this7._deferred.reject(e);
					});
				} catch (e) {
					console.warn('Geolocation._locateUser:', e);
					this._deferred.reject();
				}
				return this._deferred.promise();
			}
		}, {
			key: 'getUserLocation',
			value: function getUserLocation() {
				return this._locateUser().then(function (response) {
					return {
						longitude: response.location.longitude,
						latitude: response.location.latitude
					};
				});
			}
		}]);

		return Geolocation;
	}();

	theme.geolocation = new Geolocation();
})(window.theme = window.theme || {}, jQuery);

/**
 * STORE LOCATION LIBRARY
 *
 * @description Facilitates access to a store's information.
 * @namespace store_location
 */
(function (theme) {
	var StoreLocation = function () {
		function StoreLocation(data) {
			_classCallCheck(this, StoreLocation);

			this._data = data || {};
		}

		_createClass(StoreLocation, [{
			key: 'getAddress',
			value: function getAddress() {
				return this._data.address || {};
			}
		}, {
			key: 'getHours',
			value: function getHours() {
				return this._data.open_hours || [];
			}
		}, {
			key: 'getTodayHours',
			value: function getTodayHours() {
				if (!this.openInStore) {
					return null;
				}
				return this.getHours()[new Date().getDay()] || null;
			}
		}, {
			key: 'getTomorrowHours',
			value: function getTomorrowHours() {
				if (!this.openInStore) {
					return null;
				}
				return this.getHours()[new Date().getDay() + 1] || null;
			}
		}, {
			key: 'getDirectionsUrl',
			value: function getDirectionsUrl(location) {
				var url = 'https://www.google.com/maps/dir/?api=1';
				url += '&destination=' + encodeURIComponent(this.address_street + ', ' + this.address_city + ', ' + this.address_province + ' ' + this.address_postal_code);
				if (location) {
					url += '&origin=' + encodeURIComponent(location.latitude + "," + location.longitude);
				}
				return url;
			}
		}, {
			key: 'getLatLng',
			value: function getLatLng() {
				return {
					lat: this.getAddress().latitude,
					lng: this.getAddress().longitude
				};
			}
		}, {
			key: 'store_code',
			get: function get() {
				return this._data.store_code;
			}
		}, {
			key: 'address_name',
			get: function get() {
				return this.getAddress().city;
			}
		}, {
			key: 'address_street',
			get: function get() {
				return this.getAddress().street;
			}
		}, {
			key: 'address_line1',
			get: function get() {
				return this.getAddress().address1;
			}
		}, {
			key: 'address_line2',
			get: function get() {
				return this.getAddress().address2;
			}
		}, {
			key: 'address_city',
			get: function get() {
				return this.getAddress().city;
			}
		}, {
			key: 'address_province',
			get: function get() {
				return this.getAddress().province;
			}
		}, {
			key: 'address_province_code',
			get: function get() {
				return this.getAddress().province_code;
			}
		}, {
			key: 'address_postal_code',
			get: function get() {
				return this.getAddress().postal_code;
			}
		}, {
			key: 'address_country',
			get: function get() {
				return this.getAddress().country;
			}
		}, {
			key: 'address_country_code',
			get: function get() {
				return this.getAddress().country_code;
			}
		}, {
			key: 'phone',
			get: function get() {
				return this._data.phone;
			}
		}, {
			key: 'latitude',
			get: function get() {
				return this.getAddress().latitude;
			}
		}, {
			key: 'longitude',
			get: function get() {
				return this.getAddress().longitude;
			}
		}, {
			key: 'open',
			get: function get() {
				return this._data.open && this.openInStore;
			}
		}, {
			key: 'openInStore',
			get: function get() {
				return 'in_store_shopping' in this._data ? this._data.in_store_shopping : true;
			}
		}, {
			key: 'today_hours',
			get: function get() {
				return this.getTodayHours();
			}
		}, {
			key: 'tomorrow_hours',
			get: function get() {
				return this.getTomorrowHours();
			}
		}, {
			key: 'hours',
			get: function get() {
				return this.getHours();
			}
		}, {
			key: 'schedule',
			get: function get() {
				var week_schedule = [].concat(_toConsumableArray(this.getHours()));
				week_schedule.push(week_schedule.shift());
				return week_schedule.reduce(function (schedule, day) {
					var previousDay = schedule[schedule.length - 1];
					if (previousDay && day.open_time == previousDay.open_time && day.close_time == previousDay.close_time) {
						previousDay.day.push(day.day);
					} else {
						schedule.push({
							day: [day.day],
							open_time: day.open_time,
							close_time: day.close_time
						});
					}
					return schedule;
				}, []);
			}
		}, {
			key: 'distance',
			get: function get() {
				if (isNaN(this._data.distance)) {
					return '';
				}
				return Math.round(this._data.distance) + 'km';
			}
		}, {
			key: 'name',
			get: function get() {
				return this._data.name;
			}
		}]);

		return StoreLocation;
	}();

	StoreLocation.prototype.toString = function () {
		return JSON.stringify(this._data);
	};

	theme.StoreLocation = StoreLocation;
})(window.theme = window.theme || {});

/**
 * STORE LOCATOR LIBRARY
 *
 * @description Handles the various store locations.
 * @namespace store_locator
 */
(function (theme, $) {
	var StoreLocator = function () {
		_createClass(StoreLocator, null, [{
			key: 'MARKERS',
			get: function get() {
				return Object.freeze({
					selected: {
						url: theme.assets.store_locator.primary_marker,
						scaledSize: new google.maps.Size(34, 34)
					},
					default: {
						url: theme.assets.store_locator.secondary_marker,
						scaledSize: new google.maps.Size(34, 34)
					}
				});
			}
		}]);

		function StoreLocator(form) {
			var _this8 = this;

			_classCallCheck(this, StoreLocator);

			this.stores = [];
			this.currentPageStores = [];
			this.currentPage = 1;
			this.pageSize = 5;
			this.endpoint = '/apps/integrations-api/v1/stores';
			this.map;
			this.mapElement = document.getElementById('map');
			this.markers = {};
			this.selectedStore;

			if (form) {
				$(form).on('submit', function (event) {
					event.preventDefault();
					_this8.getStoresByAddress($(event.currentTarget).find('.js-input').val());
				});
				$('.js-user-location').on('click', this.getStoresByPosition.bind(this));
				$('[data-paginate-store]').on('click', function (event) {
					return _this8.setCurrentPage(_this8.currentPage + parseInt(event.currentTarget.dataset.paginateStore));
				});
			}

			if (this.mapElement) {
				this.location = this.setLocation(Number($(this.mapElement).attr('data-center-lat')), Number($(this.mapElement).attr('data-center-lng')));
			}

			this.geocoderPromise = $.Deferred();
			window.initMap = function () {
				return _this8.initMap();
			};
			var apiKey = 'AIzaSyDnzoHLG1osn3GsTeJSM7yxJiFayTG0HXI';
			var gmapsApi = document.createElement('script');
			gmapsApi.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initMap');
			if (!document.querySelector('script[src="' + gmapsApi.src + '"]')) {
				document.getElementsByTagName("head")[0].appendChild(gmapsApi);
			} else if (window.google && google.maps) {
				this.initMap();
			}
		}

		_createClass(StoreLocator, [{
			key: 'setStores',
			value: function setStores(stores) {
				this.stores = stores;
				this.setCurrentPage(1);
				return this.stores;
			}
		}, {
			key: 'setCurrentPage',
			value: function setCurrentPage(page) {
				this.currentPage = Math.max(Math.min(page, Math.ceil(this.stores.length / this.pageSize)), 1);
				this.currentPageStores = this.stores.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
				this.displayPage();
				this.updatePagination();
				return this.currentPage;
			}
		}, {
			key: 'setLocation',
			value: function setLocation(latitude, longitude) {
				this.location = new theme.Coordinates(latitude, longitude);
				return this.location;
			}
		}, {
			key: 'initMap',
			value: function initMap() {
				this.geocoderPromise.resolve(new google.maps.Geocoder());
				if (this.mapElement) {
					this.map = new google.maps.Map(this.mapElement, {
						center: this.location.getLatLng(),
						maxZoom: 16,
						zoom: 10,
						disableDefaultUI: true
					});
					this.renderMarkers();
				}
			}
		}, {
			key: 'getGeocoder',
			value: function getGeocoder() {
				return this.geocoderPromise.promise();
			}
		}, {
			key: 'getStores',
			value: function getStores(params) {
				var _this9 = this;

				var params = {
					latitude: this.location.getLatitude(),
					longitude: this.location.getLongitude(),
					radius: 1000,
					units: 'km',
					brands: ['boathouse'],
					limit: 10
				};
				return $.get(this.endpoint, params).then(function (response) {
					return _this9.setStores(response.stores.map(function (store) {
						return new theme.StoreLocation(store);
					}));
				}, function (error) {
					return [];
				});
			}
		}, {
			key: 'getStoreByCode',
			value: function getStoreByCode(store_code) {
				return this.stores.filter(function (store) {
					return store.store_code == store_code;
				})[0];
			}
		}, {
			key: 'getStoresByPosition',
			value: function getStoresByPosition() {
				var _this10 = this;

				this.getPosition().then(function (position) {
					_this10.setLocation(position.coords.latitude, position.coords.longitude);
					_this10.getStores();
					_this10.updateSearchTitle('position');
				}, function (error) {
					_this10.setStores([]);
					$('.js-loc-disabled').addClass('c-store-locator__stores-location-disabled--active');
				});
			}
		}, {
			key: 'getStoresByAddress',
			value: function getStoresByAddress(address) {
				var _this11 = this;

				this.geocodeAddress(address).then(function (position) {
					_this11.setLocation(position.lat(), position.lng());
					_this11.getStores();
				}, function (error) {
					_this11.setStores([]);
				}).always(function () {
					_this11.updateSearchTitle('address', address);
				});
			}
		}, {
			key: 'getPosition',
			value: function getPosition() {
				var deferred = $.Deferred();
				navigator.geolocation.getCurrentPosition(function (position) {
					return deferred.resolve(position);
				}, function (err) {
					return deferred.reject(err);
				});
				return deferred.promise();
			}
		}, {
			key: 'geocodeAddress',
			value: function geocodeAddress(address) {
				var deferred = $.Deferred();
				this.getGeocoder().done(function (geocoder) {
					geocoder.geocode({
						address: address,
						componentRestrictions: { country: 'CA' }
					}, function (results, status) {
						if (status == 'OK') {
							deferred.resolve(results[0].geometry.location);
						} else {
							deferred.reject(status);
						}
					});
				});
				return deferred.promise();
			}
		}, {
			key: 'displayPage',
			value: function displayPage() {
				if (this.stores.length === 0) {
					$('.js-stores').html('');
					$('.js-store-locator').addClass('c-store-locator--no-results');
					return;
				}
				$('.js-loc-disabled').removeClass('c-store-locator__stores-location-disabled--active');
				$('.js-store-locator').removeClass('c-store-locator--no-results');
				$('.js-stores').html(this.currentPageStores.reduce(this.renderStore.bind(this), ''));
				this.renderMarkers();
				this.updatePagination();
			}
		}, {
			key: 'renderStore',
			value: function renderStore(html, store) {
				var current_time = ("0" + new Date().getHours()).slice(-2) + ':' + new Date().getMinutes();
				var store_schedule = '';
				if (store.getHours().length) {
					store_schedule = store.schedule.reduce(function (html, day) {
						return html + ('\n\t\t\t\t\t\t<div class="store__store-weekly-hours">\n\t\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\t\t' + day.day.filter(function (element, index, array) {
							return index == 0 || index == array.length - 1;
						}).join('-') + '\n\t\t\t\t\t\t\t</strong>:\n\t\t\t\t\t\t\t' + day.open_time + '-' + day.close_time + '\n\t\t\t\t\t\t</div>\n\t\t\t\t\t');
					}, '<div class="store__store-hours js-show-hours">Store Hours</div>');
				}

				return html + '<div id="' + store.store_code + '" class="store js-store' + (this.selectedStore && this.selectedStore.store_code == store.store_code ? ' store--selected' : '') + '">' + '<div class="store__name">' + store.name + '</div>' + '<div class="store__distance">' + store.distance + '</div>' + '<div class="store__address">' + store.address_street + '<br />' + store.address_city + ', ' + store.address_province_code + ' ' + store.address_postal_code + '<br />' + store.phone + '</div>' + '<div class="store__open-hours">' + (store.open ? '<strong>Open</strong>' : '<strong>Closed</strong>') + (store.today_hours ? ' until ' + (store.open ? store.today_hours.close_time : current_time > store.today_hours.close_time ? store.tomorrow_hours.open_time : store.today_hours.open_time) : '') + '</div>' + '<div class="store__selector"><button type="button" class="js-store-chooser" data-store-code="' + store.store_code + '"><span class="selected">My store</span><span class="selection">Make this my store</span></button></div>' + '<div class="store__show-directions"><a href=" ' + store.getDirectionsUrl(this.location.getPosition()) + '" target=_blank> Show Directions </a></div>' + store_schedule + '</div>';
			}
		}, {
			key: 'updateMarker',
			value: function updateMarker(store_code, marker) {
				if (store_code in this.markers) {
					this.markers[store_code].setIcon(marker);
				}
			}
		}, {
			key: 'renderMarkers',
			value: function renderMarkers() {
				var _this12 = this;

				if (!this.map) {
					return;
				}
				var bounds = new google.maps.LatLngBounds();
				this.clearMarkers();

				this.currentPageStores.forEach(function (store) {
					var storePosition = new theme.Coordinates(store.latitude, store.longitude);
					var marker = new google.maps.Marker({
						position: storePosition.getLatLng(),
						map: _this12.map,
						icon: StoreLocator.MARKERS[_this12.isSelectedStore(store) ? 'selected' : 'default'],
						animation: google.maps.Animation.DROP
					});
					_this12.markers[store.store_code] = marker;

					bounds.extend(storePosition.getLatLng());
				});

				this.map.fitBounds(bounds);
			}
		}, {
			key: 'clearMarkers',
			value: function clearMarkers() {
				for (var marker in this.markers) {
					this.markers[marker].setMap(null);
				}
				this.markers = {};
				return this.markers;
			}
		}, {
			key: 'updatePagination',
			value: function updatePagination() {
				var firstresult = (this.currentPage - 1) * this.pageSize + 1,
				    lastresult = Math.min(this.currentPage * this.pageSize, this.stores.length);
				$('.js-results').text('Showing results ' + firstresult + ' - ' + lastresult);
				$('.c-pagination__arrow--previous').prop('disabled', firstresult == 1);
				$('.c-pagination__arrow--next').prop('disabled', lastresult == this.stores.length);
			}
		}, {
			key: 'updateSearchTitle',
			value: function updateSearchTitle(mode) {
				var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

				$('.c-store-locator__title').attr('data-search-mode', mode).attr('data-search-query', query);
			}
		}, {
			key: 'updateMapCenter',
			value: function updateMapCenter() {
				this.map.panTo(this.selectedStore.getLatLng());
			}
		}, {
			key: 'selectStore',
			value: function selectStore(store_code) {
				var store = this.getStoreByCode(store_code);
				if (!store) {
					return;
				}

				// Deselect the previous store
				if (this.selectedStore) {
					this.updateMarker(this.selectedStore.store_code, StoreLocator.MARKERS.default);
				}

				// Select the new store
				this.selectedStore = store;
				this.updateMarker(store.store_code, StoreLocator.MARKERS.selected);
				return this.selectedStore;
			}
		}, {
			key: 'isSelectedStore',
			value: function isSelectedStore(store) {
				return this.selectedStore && store.store_code == this.selectedStore.store_code;
			}
		}, {
			key: 'getSelectedStore',
			value: function getSelectedStore() {
				return this.selectedStore;
			}
		}]);

		return StoreLocator;
	}();

	theme.StoreLocator = StoreLocator;
})(window.theme = window.theme || {}, jQuery);

/**
 * CUSTOMER LIBRARY
 *
 * @description Handles the customer object.
 * @namespace store_location
 */
(function (theme) {
	var Customer = function () {
		_createClass(Customer, null, [{
			key: 'STORAGE_KEYS',
			get: function get() {
				return Object.freeze({
					preferred_shipping: 'preferred_shipping',
					preferred_store: 'preferred_store'
				});
			}
		}, {
			key: 'CART_ATTRIBUTES',
			get: function get() {
				return Object.freeze({
					pickup_store_code: 'pickup_store_code',
					shipping_method: 'shipping_method'
				});
			}
		}, {
			key: 'SHIPPING_KEYS',
			get: function get() {
				return Object.freeze({
					ship_to_store: 'ship_to_store',
					delivery: 'delivery'
				});
			}
		}]);

		function Customer() {
			_classCallCheck(this, Customer);

			this.locatePromise = null;

			try {
				var preferred_store = JSON.parse(localStorage.getItem(Customer.STORAGE_KEYS.preferred_store));
				if (preferred_store) {
					theme.cart.fetch().then(function (cart) {
						if (!cart.attributes[Customer.CART_ATTRIBUTES.pickup_store_code]) {
							var _theme$cart$updateAtt;

							theme.cart.updateAttributes((_theme$cart$updateAtt = {}, _defineProperty(_theme$cart$updateAtt, Customer.CART_ATTRIBUTES.pickup_store_code, preferred_store.store_code), _defineProperty(_theme$cart$updateAtt, Customer.CART_ATTRIBUTES.shipping_method, null), _theme$cart$updateAtt));
							sessionStorage.removeItem(Customer.STORAGE_KEYS.preferred_shipping);
						}
					});
				}
			} catch (e) {
				console.warn(e);
			}
		}

		_createClass(Customer, [{
			key: 'getPreferredStore',
			value: function getPreferredStore() {
				try {
					var store = JSON.parse(localStorage.getItem(Customer.STORAGE_KEYS.preferred_store));
					if (store) {
						return $.when(new theme.StoreLocation(store));
					}

					return this.locateNearestStore();
				} catch (e) {
					console.warn(e);
					return this.locateNearestStore();
				}
			}
		}, {
			key: 'setPreferredStore',
			value: function setPreferredStore(store) {
				try {
					localStorage.setItem(Customer.STORAGE_KEYS.preferred_store, store);
				} catch (e) {
					// TODO: Delete the pickup_store_code cart attribute?
					console.error('Customer.setPreferredStore:', e);
				}

				return theme.cart.updateAttributes(_defineProperty({}, Customer.CART_ATTRIBUTES.pickup_store_code, store.store_code)).then(function () {
					return store;
				});
			}
		}, {
			key: 'locateNearestStore',
			value: function locateNearestStore() {
				var _this13 = this;

				if (!this.locatePromise) {
					var storeLocator = window.storeLocator || new theme.StoreLocator();
					this.locatePromise = theme.geolocation.getUserLocation().then(function (location) {
						storeLocator.setLocation(location.latitude, location.longitude);
						return storeLocator.getStores(location);
					}).then(function (stores) {
						return _this13.setPreferredStore(stores[0]);
					});
				}
				return this.locatePromise;
			}
		}, {
			key: 'getPreferredShipping',
			value: function getPreferredShipping() {
				var shipping = JSON.parse(sessionStorage.getItem(Customer.STORAGE_KEYS.preferred_shipping));
				return $.when(shipping);
			}
		}, {
			key: 'setPreferredShipping',
			value: function setPreferredShipping(shipping) {
				if (!(shipping in Customer.SHIPPING_KEYS)) {
					shipping = null;
				}

				try {
					sessionStorage.setItem(Customer.STORAGE_KEYS.preferred_shipping, JSON.stringify(shipping));
					sessionStorage.setItem('shipment_flag', 'true');
				} catch (e) {
					console.error(e);
				}

				return theme.cart.updateAttributes(_defineProperty({}, Customer.CART_ATTRIBUTES.shipping_method, shipping)).then(function () {
					return theme.cart.content.attributes[Customer.CART_ATTRIBUTES.shipping_method];
				});
			}
		}, {
			key: 'isShipToStore',
			value: function isShipToStore() {
				return this.getPreferredShipping().then(function (shipping_method) {
					if (shipping_method !== null) {
						return shipping_method;
					}
					if (theme.cart.content.attributes) {
						return theme.cart.content.attributes[Customer.CART_ATTRIBUTES.shipping_method];
					}
					return theme.cart.fetch().then(function (cart) {
						return cart.attributes[Customer.CART_ATTRIBUTES.shipping_method];
					});
				}).then(function (shipping_method) {
					return shipping_method === Customer.SHIPPING_KEYS.ship_to_store;
				});
			}
		}]);

		return Customer;
	}();

	theme.customer = new Customer();
})(window.theme = window.theme || {});

(function (theme, $) {
	/**
  * Modal LIBRARY
  *
  * @description Handles the Shopify modal interactions.
  * @namespace Modal
  * @example To create anew modal you do the following --> var new_modal = new theme.Modal('modal-id'); new_modal.show();
  */
	var Modal = function () {
		/**
   * Creates an instance of Modal
   *
   * @param {string} id - The id of the modal
   * @param {object} params - Parameters to modify the classe's behaviour
   * @constructs Modal
   * @memberof Modal
   */
		function Modal(id, params) {
			_classCallCheck(this, Modal);

			this.modal = document.getElementById(id);

			if (!this.modal) {
				return false;
			}

			this.defaults = {
				backdrop_fade_in_delay: 500,
				backdrop_fade_out_delay: 1000,
				backdrop_opacity: 0.68,
				backdrop_selector: '.modal__backdrop',
				close_event: 'click',
				close_selector: '[data-modal-close]',
				container_fade_in_delay: 500,
				container_fade_out_delay: 500,
				container_selector: '.modal__container',
				modal_state_open: "modal--open"
			};

			this.options = $.extend({}, this.defaults, params || {});

			this.backdrop = this.modal.querySelector(this.options.backdrop_selector);
			this.container = this.modal.querySelector(this.options.container_selector);
			this.closers = this.modal.querySelectorAll(this.options.close_selector);

			this.bindListeners();
		}

		_createClass(Modal, [{
			key: 'show',
			value: function show() {
				$(this.modal).addClass(this.options.modal_state_open);
				$(this.backdrop).fadeTo(this.options.backdrop_fade_in_delay, this.options.backdrop_opacity);
				$(this.container).fadeIn(this.options.container_fade_in_delay);
				$(this.modal).trigger('modal_show');
			}
		}, {
			key: 'hide',
			value: function hide() {
				$(this.modal).removeClass(this.options.modal_state_open);
				$(this.backdrop).fadeOut(this.options.backdrop_fade_out_delay);
				$(this.container).fadeOut(this.options.container_fade_out_delay);
				$(this.modal).trigger('modal_hide');
			}
		}, {
			key: 'bindListeners',
			value: function bindListeners() {
				var _this14 = this;

				for (var i = 0; i < this.closers.length; i++) {
					$(this.closers[i]).on(this.options.close_event, function () {
						_this14.hide();
					});
				}
			}
		}]);

		return Modal;
	}();

	theme.Modal = Modal;
})(window.theme = window.theme || {}, jQuery);

(function (theme, $) {

	/**
  * A Dropdown class encapsulates a set of dropdown
  * elements that contain close and toggle buttons.
  * The actual open and close animation is handled with
  * CSS through the 'is-open' class on the container.
  * @class
  */
	var Dropdown = function () {
		function Dropdown($container) {
			var _this15 = this;

			_classCallCheck(this, Dropdown);

			this.elements = {
				$container: $container,
				$trigger: $('.js-dropdown-trigger', $container),
				$close: $('.js-dropdown-close', $container),
				$options: $('.js-dropdown-option', $container),
				$value_indicators: $('.js-dropdown-value', $container)

				// Toggle or close the dropdown based on the element
			};this.elements.$trigger.on('click', this.toggle.bind(this));
			this.elements.$close.on('click', this.close.bind(this));
			this.elements.$options.on('click', function (event) {
				_this15.elements.$value_indicators.text(event.currentTarget.dataset.value);
				_this15.close();
			});

			// Create a unique handler that can be bound and unbound to the document
			this.check_close = function (event) {
				return _this15.checkClose.call(_this15, event);
			};
		}

		/**
   * Toggle the dropdown
   */


		_createClass(Dropdown, [{
			key: 'toggle',
			value: function toggle() {
				if (this.elements.$container.hasClass('is-open')) {
					this.close();
				} else {
					this.open();
				}
			}
			/**
    * Open the dropdown
    */

		}, {
			key: 'open',
			value: function open() {
				this.elements.$container.addClass('is-open');
				$(document).on('click.dropdown', this.check_close);
			}

			/**
    * Close the dropdown
    */

		}, {
			key: 'close',
			value: function close() {
				this.elements.$container.removeClass('is-open');
				$(document).off('click.dropdown', this.check_close);
			}

			/**
    * Check if the click event is outside of the dropdown, and close the dropdown if the
    * user has clicked away from the dropdown
    * @param {Object} event - Event information
    */

		}, {
			key: 'checkClose',
			value: function checkClose(event) {
				if (event.target !== this.elements.$container[0] && !$.contains(this.elements.$container[0], event.target)) {
					this.close();
				}
			}
		}]);

		return Dropdown;
	}();

	theme.Dropdown = Dropdown;
	$('.js-dropdown').each(function (index, element) {
		return new Dropdown($(element));
	});
})(window.theme = window.theme || {}, jQuery);

// ------------------------------
// PARTIALS
// ------------------------------
(function ($) {
	var returnFormWrapper = document.querySelector('.js-form-return');
	var challenge = document.querySelector('.shopify-challenge__container');

	// If in form page, step 1 and 3
	if (returnFormWrapper) {

		// Step 1
		var returnForm = document.querySelector('.contact-form');
		var formSuccess = document.querySelector('.js-form-return-sent');

		returnForm.addEventListener('submit', function (e) {
			e.preventDefault();
			sessionStorage.setItem('returnForm', 'submitted');

			returnForm.submit();
		});

		// Step 3
		if (sessionStorage.getItem('returnForm') == 'confirmed') {
			formSuccess.classList.add('form-return__success--active');
			sessionStorage.removeItem('returnForm');
		}

		/* if(formSuccess.classList.contains('form-return__success--active')) {
    setTimeout(function(){
      window.location.href = "https://www.canadapost.ca/cpotools/apps/prse/label?execution=e1s1";
    }, 5000);
  } */
	}

	// If in captcha page, Step 2
	if (challenge && sessionStorage.getItem("returnForm") == 'submitted') {
		var challengeForm = challenge.querySelector('form');

		challengeForm.addEventListener('submit', function (e) {
			e.preventDefault();

			if (grecaptcha.getResponse()) {
				sessionStorage.setItem('returnForm', 'confirmed');
				challengeForm.submit();
			}
		});
	}
})(jQuery);

/**
 * Function to update $ away from free shipping
 * 
 */

function updateFreeShipping(current_bag_amt) {
	var free_shipping_amt = parseFloat($('.js-cart__shipping-msg').data('minFree'));
	var free_shipping_left = parseFloat(free_shipping_amt) - parseFloat(current_bag_amt);
	if (free_shipping_amt < current_bag_amt) {
		var free_shipping_msg = $('.total__free-shipping').data('freeMsg');
		$('.js-cart__shipping-msg').text(free_shipping_msg);
	} else {
		var free_shipping_money_left = theme.utils.toMoney(free_shipping_left * 100, { cents: true });
		$('.shipping-msg__price').text(free_shipping_money_left);
		$('.total__free-shipping').html('<span>You are <span class="shipping-msg__price">' + free_shipping_money_left + '</span> away from FREE SHIPPING</span>');
	}
}

function updateShippingSelectors($container) {
	$('.js-dropdown', $container).each(function (index, element) {
		return new theme.Dropdown($(element));
	});
	$('.js-shipping-method-selector', $container).each(function (index, element) {
		return new theme.ShippingMethodChooser($(element));
	});
}

/**
 * Reload Layout of Cart
 * 
 */

function reloadCartLayout() {
	var $cart_container = $('.cart__container');

	if ($cart_container.length === 0) {
		return $.when();
	}

	return $.get('/cart?view=cart', function (data) {
		var cart_info = $(data).find('.cart__container');
		var current_bag_amt = theme.cart.content.total_price / 100;

		$cart_container.html(cart_info);
		updateFreeShipping(current_bag_amt);
		updateShippingSelectors($cart_container);
	});
}

/**
 * Reload Layout of Flyout
 * 
 */

function reloadCartFlyout() {
	return $.get('/cart?view=cart_flyout', function (data) {
		var cart_info = $(data).find('.cart__flyout');
		var $flyout = $('#flyout');
		$flyout.html(cart_info);
		updateShippingSelectors($flyout);
		if ($('.nav__cart').hasClass('open-on-refresh')) {
			toggleFlyout($('.nav__cart'));
			$('.nav__cart').removeClass('open-on-refresh').addClass('nav__util--active');
		}
	});
}

/**
 * Ajax Remove Line Item
 * 
 */

$('#cart').on('click', '.cart__item--remove', function () {
	var item_id_remove = $(this).siblings('.cart__item--qty').find('button').data('id');
	$('.nav__cart').addClass('open-on-refresh');
	theme.cart.update({ id: item_id_remove, quantity: 0 });
});

/**
* Ajax Update Line Item - Updates the Price and Subtotal
* 
*/

$('#cart').on('click', '.cart__item--qty .js-cart-update', function (e) {
	e.preventDefault();
	var item_id = $(this).data('id');
	var item_qty = $(this).siblings('input').val();
	$('.nav__cart').addClass('open-on-refresh');
	theme.cart.update({ id: item_id, quantity: item_qty });
	return false;
});

// Update the cart on ship to store updated
$(document).on('cart_set', function () {
	if (window.noCartReload) {
		return;
	}
	$('.nav__cart.nav__util--active').addClass('open-on-refresh');
	$.when(reloadCartLayout(), reloadCartFlyout()).then(function () {
		return theme.cart_inventory.validateInventory();
	});
});

$(function () {
	$('.remap').rwdImageMaps();
});

/*
$(function(){
       var feed = new Instafeed({
            get: 'user',
            userId: '253163172',
            clientId: '2bd064f2e0c845fe9ccb50a9962f3b6c',
            resolution: 'low_resolution',
            accessToken: "253163172.1677ed0.86790a83558a4da8b5bcaaa5b4b19b84",
            limit: "20",
            template: "<div class='instafeed-picture'><a class='instafeed-link' href='{{link}}' target='_blank'><div style='background-image:url({{image}}); padding-bottom: 100%; background-size: cover; background-repeat: no-repeat;' /></div></a></div>",
               success: function success() {}
       });
    feed.run();
});
*/

/**
 * createProductSlider:
 * Creates thumbnail and main image sliders.
 *
 * @param {(object)}  $nav: vertical slider for nav (thumbnails) of the main image slider
 * @param {string} main_slider: class/id of the main image slider
 */
function createProductSlider($nav, main_slider) {
	$nav.slick({
		slidesToShow: 7,
		slidesToScroll: 1,
		asNavFor: main_slider,
		focusOnSelect: true,
		vertical: true,
		dots: false,
		infinite: false,
		draggable: true,
		verticalSwiping: true
	});

	$(main_slider).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		focusOnSelect: false,
		infinite: false,
		dots: false,
		arrows: false,
		draggable: false,
		responsive: [{
			breakpoint: 768,
			settings: {
				draggable: false
			}
		}, {
			breakpoint: 0,
			settings: {
				draggable: true
			}
		}]
	});
}

$('.image-button-next').on('click', function () {
	$('#image-view').slick("slickNext");
});

$('.image-button-prev').on('click', function () {
	$('#image-view').slick("slickPrev");
});

/**
 * updateVariantPrice: Hide/Show variant prices depending on selected ID
 *
 * @param {string} varID: variant id
 */
function updateVariantPrice(varID) {
	$('.product__details .price').hide();
	$('.price-variant-' + varID).show();
}

function createCardSlider(slider) {
	if ($(window).width() > 767 && $(slider).hasClass('slick-initialized')) {
		$(slider).slick('unslick');
	} else if ($(window).width() < 768 && !$(slider).hasClass('slick-initialized')) {
		if ($(slider).children().length == 1) {
			$(slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				focusOnSelect: false,
				infinite: false,
				dots: false,
				arrows: false,
				draggable: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						draggable: false
					}
				}, {
					breakpoint: 0,
					settings: {
						draggable: true
					}
				}]
			});
		} else {
			$(slider).slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				focusOnSelect: false,
				infinite: false,
				dots: false,
				arrows: false,
				draggable: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						draggable: false
					}
				}, {
					breakpoint: 0,
					settings: {
						draggable: true
					}
				}]
			});
		}
	}
}
/**
 * getSelectedProductID: returns Variant ID
 *
 * @param {(object)}  $selector: variant selector container
 * @param {string} optionClass: class contained on each variant option if radio or on selectbox/hidden input
 */
function getSelectedProductID($selector, optionClass) {
	var $optionObject = $selector.find(optionClass);
	if ($optionObject.is('select')) {
		return $optionObject.find('option:selected').val();
	} else if ($optionObject.is('input[type=radio]')) {
		var value = $selector.find(optionClass + ':checked').val();
		return value;
	} else {
		return $optionObject.val();
	}
}
function addToCart($variantContainer, variantOptionClass, $quantity) {
	var item = {};
	item.quantity = 1;
	var $selectedQuantity = $quantity,
	    $selectedVariants = $variantContainer;

	if ($selectedQuantity.length > 0) {
		item.quantity = $selectedQuantity.val();
	}

	if ($selectedVariants.length > 0) {
		item.id = getSelectedProductID($selectedVariants, variantOptionClass);
	}
	theme.cart.add(item).then(function () {
		if (window.location.href.indexOf('fromCart') > -1) {
			window.location.href = window.theme.shop.url + '/cart';
		}
	});
}

function triggerShipmentModal(shipment_modal) {
	if (!shipment_modal.modal) {
		return $.Deferred().reject().promise();
	}

	return $.when(theme.customer.getPreferredStore(), theme.customer.getPreferredShipping()).then(function (store, shipping_method) {
		var promise = $.Deferred();

		if (!store.store_code || shipping_method) {
			promise.reject();
			return promise.promise();
		}

		var SHIP_TO_STORE = 'ship_to_store';

		$('[data-shipment-form]').off('submit.shipment_modal').on('submit.shipment_modal', function (e) {
			e.preventDefault();
			theme.customer.setPreferredShipping($('[name="shipping-method"]:checked').val()).done(function () {
				return promise.resolve();
			}, shipment_modal.hide());
		});

		$('#modal-shipping-method').off('modal_show.shipment_modal').on('modal_show.shipment_modal', function (e) {
			var $modal_open = $(e.target);
			var $shipping_container = $($modal_open.find('[data-shipment-method]'));
			var $shipping_input = $($modal_open.find('[data-shipping="' + SHIP_TO_STORE + '"] input[type="radio"]'));
			$shipping_input.prop('disabled', $shipping_container.hasClass('status--unavailable'));
		});

		shipment_modal.show();
		return promise.promise();
	});
}

$(function () {

	var shipment_modal = new theme.Modal('modal-shipping-method');

	createProductSlider($('#image-controller'), '#image-view');

	$('.product__variants').on('change', 'select option, input[type=radio]', function () {
		var varID = $(this).val();
		updateVariantPrice(varID);
		$(document).trigger('variant:change');
	});

	$('.product__variants select option:selected, .product__variants input[type=radio]:checked').trigger('change');

	$('.product__form').on('submit', function (e) {
		e.preventDefault();
		var local_storage_id = localStorage.getItem('edit_id');
		var form_serialized = $(this).serialize();
		var queue = $.when();
		if (window.location.href.indexOf('fromCart') > -1) {
			window.noCartReload = true;
			queue = queue.then(function () {
				return theme.cart.update({ id: local_storage_id, quantity: 0 });
			}).always(function () {
				return window.noCartReload = false;
			});
		}
		queue.then(function () {
			return $.ajax({
				url: "/cart/add.js",
				data: form_serialized,
				type: "POST",
				dataType: "json"
			}).done(function () {
				$('.nav__cart').addClass('open-on-refresh');
				$('.product__cart-error').empty();
			}).fail(function (xhr) {
				if (xhr.status == 422) {
					var response = xhr.responseJSON;
					$('.product__cart-error').text(response.description);
				}
			});
		}).then(function () {
			return triggerShipmentModal(shipment_modal).fail(function () {
				return theme.cart.fetch();
			});
		});
	});

	createCardSlider('.featured-products__recommended--product');

	$(window).resize(function () {
		createCardSlider('.featured-products__product-tiles');
		createCardSlider('.featured-products__recommended--product');
	});

	/**
   * Checking where Add to Cart coming from
   */

	if (window.location.href.indexOf('fromCart') > -1) {
		$('.product__atc').text('Update Cart');
		$('.product__quantity-container input').val(localStorage.getItem('edit_qty'));
	}

	$(document).on('cart_fetch cart_update', function (event, cart) {
		$('.nav__cart .cart__count').text(cart.item_count);
		var current_bag_amt = cart.total_price / 100;
		updateFreeShipping(current_bag_amt);
	});

	if (document.getElementById('store-locator_modal')) {
		theme.store_locator_modal = new theme.Modal('store-locator_modal');
		$('.js-open-store-locator-modal').click(function () {
			theme.store_locator_modal.show();
		});
	}
});
$(function () {
	function reinstanceZoom($prodObj) {
		if (!$prodObj.find('.zoomImg').length > 0) {
			$prodObj.zoom({
				url: $(this).data('image-zoom'),
				touch: false
			});
		}
	}

	function destroyZoom($prodObj) {
		if ($prodObj.find('.zoomImg').length > 0) {
			$prodObj.trigger('zoom.destroy');
		}
	}

	if ($(window).width() <= 1024) {
		destroyZoom($('.product_picture'));
	} else {
		reinstanceZoom($('.product_picture'));
	}

	$(window).resize(function () {
		if ($(window).width() <= 1024) {
			destroyZoom($('.product_picture'));
		} else {
			reinstanceZoom($('.product_picture'));
		}
	});
});
/**
 * Toggles Flyouts
 *
 * @param {(object)} $this - The object containing the data-attribute flyout-toggle to open the flyout
 * @example
 * Open cart flyout
 * toggleMenu($('.nav__cart'));
 */
function toggleFlyout($this) {
	var flyout = $this.data('flyoutToggle');
	if (flyout != '') {
		var flyoutClass = '.' + flyout + '__flyout';
		$('.flyout--open').not(flyoutClass).removeClass('flyout--open');
		$(flyoutClass).toggleClass('flyout--open');
		$('.nav__util--active').not($($this)).removeClass('nav__util--active');
		$($this).toggleClass('nav__util--active');
	}
}

/**
 * Remove Line Item
 * @example
 * Making Line Item qty 0
 * removeLineItem(line_item_id);
 *
 */

function removeLineItem(item_id) {
	theme.cart.remove(item_id).then(function (data) {
		if (data.total_price == 0) {
			var updated_total = '$0.00';
			theme.cart.clear();
			if (data.item_count == 0) {
				$('.flyout__contents__contain').append('<div class="flyout__contents__empty"><p>You have no items in your shopping cart.</p></div>');
				$('.flyout__footer').addClass('flyout__footer--hide');
			}
		} else {
			var updated_total = theme.utils.toMoney(data.total_price, { cents: true });
			$('.flyout__footer').removeClass('flyout__footer--hide');
		}

		$('.nav__cart .cart__count').text(data.item_count);
		$('.flyout__footer__total .subtotal--money').text(updated_total);
	});
}

$(function () {
	//toggle classes for mobile menu accordion
	var toggle = {
		parent: 'header__nav',
		child: 'nav__item',
		grandchild: 'nav__item-child'
		//menu classes for mobile menu accordion
	};var menu = {
		parent: '.nav__list',
		child: '.nav__list-child',
		grandchild: '.nav__list-grandchild'

		/**
   * Toggles Fixed Header on scroll
   *
   * @param {(object)} $header - The object that will be fixed when
   * @param {(object)} $transition - The object that triggers the header transition
   * @param {(object)} $target - The object that adjusts it's padding top on transition (object should be below $transition)
   * @example
   * // toggle #header fixed when scroll hits #topbar
   *  ogTargetPad = $('.page_main').css('padding-top');
   *   $(window).scroll(function(){
   *     toggleFixedHeader($('#header'), $('#topbar'), $('.page_main'));
   *  })
   */
		//set variable for original padding
	};var ogTargetPad = -1;
	function toggleFixedHeader($header, $transition, $target) {
		var scrollTop = $(window).scrollTop(),
		    transitionPoint = $transition.offset().top + $transition.outerHeight(),
		    headerHeight = $header.outerHeight();
		if (scrollTop >= transitionPoint) {
			$header.addClass('header-fixed');
			$target.css('padding-top', headerHeight);
		} else {
			$header.removeClass('header-fixed');
			//reset target to it's original padding
			$target.css('padding-top', ogTargetPad);
		}
	}

	/**
  * Toggle mobile menu and its submenus
  *
  * @param {(object)}  $this: the toggle for the menu
  * @example
  * toggleMenu($(this));
  */
	function toggleMenu($this) {
		if ($this.hasClass(toggle.parent)) {
			var $parentmenu = $this.find(menu.parent);
			//toggle accordion
			$parentmenu.toggleClass('menu__open');
			//if not open, close all children and grandchildren
			if (!$parentmenu.hasClass('menu__open')) {
				//close all open menus
				$parentmenu.find('.menu__open').removeClass('menu__open');
				//adjust chevron
				$this.find('.fa-chevron-right').removeClass('fa-rotate-90');
				//remove scroll lock on body and html
				$('html, body').removeClass('scroll_lock');
				//close navigation menu
				$('.nav').removeClass('nav__open');
			} else {
				//prevent page from scrolling when menu is open
				$('html, body').addClass('scroll_lock');
				//open navigation menu
				$('.nav').addClass('nav__open');
				//close flyouts
				$('.flyout--open').removeClass('flyout--open');
			}
		} else if ($this.hasClass(toggle.child)) {
			var $childmenu = $this.find(menu.child);
			//toggle accordion
			$childmenu.toggleClass('menu__open');
			//if not open, close all grandchildren
			if (!$childmenu.hasClass('menu__open')) {
				//close all grand-children accordions
				$childmenu.find('.menu__open').removeClass('menu__open');
				//adjust grand-children chevron
				$childmenu.find('.fa-chevron-right').removeClass('fa-rotate-90');
				//adjust chevron
				$this.find('.fa-chevron-right').removeClass('fa-rotate-90');
			} else {
				//adjust chevrons
				$this.children('.menu_toggle-primary').find('.fa-chevron-right').addClass('fa-rotate-90');
			}
		} else if ($this.hasClass(toggle.grandchild)) {
			var $grandchildmenu = $this.find(menu.grandchild);
			//toggle accordion
			$grandchildmenu.toggleClass('menu__open');
			if (!$grandchildmenu.hasClass('menu__open')) {
				//adjust chevron
				$this.find('.fa-chevron-right').removeClass('fa-rotate-90');
			} else {
				//adjust chevron
				$this.find('.fa-chevron-right').addClass('fa-rotate-90');
			}
		}
	}

	/**
  * Trigger Fixed Header
  */
	if ($('#header').length > 0 && $('#topbar').length > 0 && $('.page_main').length > 0) {
		//set original padding of target
		ogTargetPad = $('.page_main').css('padding-top');
		$(window).scroll(function () {
			toggleFixedHeader($('#header'), $('#topbar'), $('.page_main'));
		});
	}

	/**
  * Trigger Menu and Submenus
  */
	$('#header').on('click', '.header__nav, .nav__item, .nav__item-child', function (e) {
		//prevent submenu click from toggling the main menu click
		e.stopPropagation();
		if ($(this).find('.nav__list-child').length > 0 || $(this).find('.nav__list-grandchild').length > 0) {
			console.log("THSODGNSDOGLM");
			console.log($(this));
			toggleMenu($(this));
		}
	});

	/**
  * Trigger Flyout
  */
	$('#header').on('click', '.nav__util, .flyout__header__close', function () {
		toggleFlyout($(this));
	});

	/**
  * Update Flyout
  */
	$('#flyout').on('click', '.line-item__qty .js-flyout-update', function () {
		var item_id = $(this).data('id');
		var $input = $(this).siblings('input');
		var item_qty = $input.val();
		var max = parseInt($input.attr('max'));

		if (max && item_qty > max) {
			item_qty = max;
			$input.val(max);
		}

		theme.cart.update({ id: item_id, quantity: item_qty }).then(function (data) {
			var updated_total = theme.utils.toMoney(data.total_price, { cents: true });
			$('.nav__cart .cart__count').text(data.item_count);
			$('.flyout__footer__total .subtotal--money').text(updated_total);
			if (item_qty == 0) {
				removeLineItem(item_id);
			}
		});
	});

	/**
  * Remove Item Flyout
  */
	$('#flyout').on('click', '.line-item__qty .line-item__qty--remove', function (e) {
		e.preventDefault();
		var item_id = $(this).parent('a').siblings('button').data('id');
		$(this).closest('.line-item').remove();

		removeLineItem(item_id);
	});

	/**
  * Click outside of Ok button in flyout
  */
	$('#flyout').on('click', '.line-item__qty input', function () {
		$(this).siblings('button').addClass('button--active');
	});

	$(document).mouseup(function (e) {
		var container = $('#flyout .line-item__qty input');

		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			container.siblings('button').removeClass('button--active');
		}
	});

	/**
  * On Clicking Edit
  */

	$('#flyout').on('click', '.line-item__edit-link', function (e) {
		e.preventDefault();
		var prod_url = $(this).closest('.line-item__edit-link').data('prodUrl');
		var prod_id = $(this).closest('a').siblings('button').data('id');
		var prod_qty = $(this).closest('a').siblings('input').val();
		localStorage.setItem('edit_id', prod_id);
		localStorage.setItem('edit_qty', prod_qty);
		window.location.href = prod_url + '?fromCart=true';
	});
});
$(function () {
	if (window.theme.template.name == "collection") {

		/**
   * showMoreFacets:
   * Hides/Shows more facets 
   * 
   * @param {Object} $this: object that triggers the expander for show more  
   */
		var showMoreFacets = function showMoreFacets($this) {
			$this.parent().toggleClass('facet__menu--expanded');
			$this.children('.showmore').toggleClass('showmore--active');
		};

		//trigger for show more


		// Result event callback
		var searchCallback = function searchCallback(results) {
			var isPagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (results.hits.length === 0) {
				// If there is no result we display a friendly message
				// instead of an empty page.
				$('.collection__product-grid').empty().html("No results");
				return;
			}
			renderHits(results); //render results
			renderFacets($facets, results); //render facets
			renderPagination(results, isPagination); //render pagination
		};

		// Result event callback for pagination


		var searchCallbackWrapper = function searchCallbackWrapper(results) {
			searchCallback(results, true);
		};

		/**
   * renderPagination: 
   * renders the number of pages, arrows, and item count for each search.
   * 
   * @param {JSON} results: The full results json returned from algolia
   */


		var renderPagination = function renderPagination(results, isPaginationNotOnLoad) {
			var numResults = results.nbHits,
			    //number of results
			numPages = results.nbPages,
			    //number of pages
			currPage = results.page,
			    //current page
			templateID = '#filtered-results-pagination',
			    //template ID
			$container = $('.collection__pagination');
			var paginationString = "View All";
			if (isPaginationNotOnLoad === true) {
				if ($('.pagination__view-all span').text().indexOf('All') > -1) {
					paginationString = 'View Pagination';
				} else {
					paginationString = 'View All';
				}
			}
			renderHandlebarPagination(templateID, $container, numResults, numPages, currPage, paginationString);
		};

		/**
   * renderPaginationString: 
   * toggle the string for the view all and view pagination
   * 
   * 
   */


		var renderPaginationString = function renderPaginationString() {
			if ($('.pagination__view-all span').text().indexOf('All') > -1) {
				$('.pagination__view-all span').text('View Pagination');
			} else {
				$('.pagination__view-all span').text('View All');
			}
		};

		var mathSign = function mathSign(x) {
			return parseInt(x / Math.abs(x) || +x);
		};

		/**
   * 
   * @param {(Object)}  
   * @param {JSON} results 
   */


		var renderFacets = function renderFacets($facets, results) {
			results.disjunctiveFacets.map(function (facet) {
				var name = facet.name;
				var facetValues = results.getFacetValues(name, {
					sortBy: ['name:asc']
				});

				//if(facetValues.every(x => /^\d+:\d+$/.test(x.name))){ //if QA complains comment this line, use line underneath
				if (/^\d+:\d+$/.test(facetValues[0].name)) {
					facetValues.sort(function (a, b) {
						var ka = +a.name.replace(/:.*$/, '');
						var kb = +b.name.replace(/:.*$/, '');
						return mathSign(ka - kb);
					});
				}

				//creates array of facet list items
				var facetsValuesList = $.map(facetValues, function (facetValue) {
					var facetValueClass = facetValue.isRefined ? 'refined' : ''; //add class if refined
					var selected = facetValue.isRefined ? 'checked' : ''; //check checkbox if refined
					var price_regex = /(\d+):(\d+)/; //digit:digit Ex. 25:50
					var unfmtd_price = price_regex.exec(facetValue.name); //execute regex returns array Ex. ['25:50', '25, '50']
					var facetTitle = facetValue.name;

					//if regex returns price range format title properly
					if (unfmtd_price) {
						var left = theme.utils.toMoney(+unfmtd_price[1]); //convert left value to money
						var right = theme.utils.toMoney(+unfmtd_price[2]); //convert right value to money
						facetTitle = left + ' - ' + right;
					}

					//create facet link
					var facetLink = '<a data-attribute="' + name + '" data-value="' + facetValue.name + '" href="#"> <input data-value="' + facetValue.name + '" type="checkbox" ' + selected + ' /> ' + facetTitle + '</a>';
					//return list item
					return '<li class="' + facetValueClass + '">' + facetLink + '</li>';
				});

				//find the correct facet menu
				var $facetsContainer = $facets.find('.filter__facets[data-facet="' + name + '"] .facet__menu');
				//add the list items to menu
				$facetsContainer.html(facetsValuesList.join(''));

				//Add showmore list items only if the number of li in selectElement ul is > 10
				//parent class already on containers that required it
				if ($facetsContainer.find('li').length > 10) {
					$facetsContainer.append('<li class="facet__menu--showmore"><span class="showmore showmore--active">Show more</span><span class="showmore">Show less</span></li>');
				}
			});
		};

		/**
   * This is ugly and should be reverted to how algolia actually worked.
   * 
   */


		var createSearchQueryString = function createSearchQueryString() {
			var filters = ['query', 'attribute:*'];
			var queryString = helper.getStateAsQueryString(filters);
			var nextUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?' + queryString;
			var docTitle = document.title;
			window.history.replaceState({}, docTitle, nextUrl);
		};

		/**
   * handleFacetClick:
   * Handles the click even on the targeted facet and does search on attribute for value
   * 
   * @param {Event} e 
   */


		var handleFacetClick = function handleFacetClick(e) {
			if (!$(e.target).is('.filter__collection-link')) {
				e.preventDefault();
				var target = e.target;
				var attribute = target.dataset.attribute;
				if (!attribute) {
					target = e.target.parentElement;
					attribute = target.dataset.attribute;
				}

				var value = target.dataset.value;

				// Because we are listening in the parent, the user might click where there is no data
				if (!attribute || !value) return;
				// The toggleRefine on facet attribute with value
				helper.toggleRefine(attribute, value).search();
				createSearchQueryString();
			}
		};

		/**
   * Register Helper: Compare
   * - Compares two values (lvalue and rvalue) with given operator.
   * - If no operator direct '=='
   * - Required 2 values else error will be thrown
   */


		/**
   * renderHandlebarPagination:
   * Renders the pagination using handlebars template given all the page details
   * 
   * @param {string} templateID: id for handlebars template
   * @param {Object} $renderedContainer: the container where the content is rendered
   * @param {Number} nbHits: Number of hits returned from search results 
   * @param {Number} nbPages: Number of pages returned from search results
   * @param {Number} currPage: Current page number 
   */
		var renderHandlebarPagination = function renderHandlebarPagination(templateID, $renderedContainer, nbHits, nbPages, currPage, paginationString) {
			var template_source = $(templateID).html(); //get the template

			//create list of pages
			var pages = [];
			for (var i = 0; i < nbPages; i++) {
				var showpage = false;
				if (i == currPage) {
					showpage = true;
				} else if (i + 1 == currPage) {
					showpage = true;
				} else if (i - 1 == currPage) {
					showpage = true;
				} else if (i + 2 == currPage) {
					showpage = true;
				} else if (i - 2 == currPage) {
					showpage = true;
				} else if (currPage < 2 && i < 5) {
					showpage = true;
				}
				if (showpage) {
					pages.push(i + 1);
				} else {
					pages.push(null);
				}
			}
			//create the object needed for handlebars
			var pageinfo = { "hits": nbHits, "current": currPage, "pages": pages, 'maxpages': nbPages - 1, "paginationString": paginationString };

			var template = Handlebars.compile(template_source); //compile the template
			$renderedContainer.html(template(pageinfo)); //render the template
		};

		/**
   * Check for a second image for on hover images
   * 
   * @param {*} results: results.hit Json returned from search
   */


		var renderHover = function renderHover(results) {
			var deferred = [];
			$.each(results, function (j, resultValue) {
				//if there is no id match between the two objects
				deferred.push($.get('/products/' + resultValue.handle + '.json').then(function (data) {
					if (data.product.images[1] != undefined) {
						var temp_hover_img = data.product.images[1].src;
						if (temp_hover_img.indexOf('no-image') < 0) {
							//add url to object
							resultValue.hover_image = temp_hover_img;
						}
					}
				}));
			});
			return deferred;
		};

		/**
   * renderHandlebarTeamplate:
   * Renders the hit results using handlebars template given the results.hits json
   * 
   * @param {JSON} results: results.hit Json returned from search
   * @param {String} templateID: id for handlebars template
   * @param {Object} $renderedContainer: the container where the content is rendered
   */


		var renderHandlebarTemplate = function renderHandlebarTemplate(results, templateID, $renderedContainer) {
			var template_source = $(templateID).html(); //get template

			var discounts = getDiscountMessage($('.product__identifier-discounts'));
			renderDiscounts(results, discounts);

			/**
    * Register Helper: Currency
    * - Converts amount to currency value.
    */
			Handlebars.registerHelper('currency', function (amount, options) {
				var numericAmount = typeof amount === 'string' ? options.contexts[0].get(amount) : amount;
				var pennies = Math.round(numericAmount * 100);
				var cents = pennies % 100;
				var dollars = Math.round(pennies / 100 - cents / 100);
				var centsStr = '' + cents;
				var result = '$' + dollars + '.' + (centsStr.length < 2 ? '0' + cents : cents);

				return '$' + dollars + '.' + (centsStr.length < 2 ? '0' + cents : cents);
			});

			// $.when.apply($, results.map(function (result) {
			// 	return $.ajax({
			// 		type: "GET",
			// 		url: '/products/'+ result.handle+'.json',
			// 		timeout: 3000,
			// 	}).then(function (data) {
			// 		if(data.product.images[1] != undefined){
			// 				let temp_hover_img = data.product.images[1].src;						
			// 				if(temp_hover_img.indexOf('no-image') < 0){
			// 					//add url to object
			// 					result.hover_image = temp_hover_img;
			// 				}
			// 			}
			// 	}).then($.noop, $.noop);
			// })).then(function () {
			var template = Handlebars.compile(template_source); //compile template
			var wrapper = { products: results }; //create object for handlebars template
			$renderedContainer.html(template(wrapper)); //render template
			//});
		};

		/**
   * renderHits:
   * calls the renderHandlebarTemplate to render all the hit results
   * 
   * @param {JSON} results: results returned from the search
   */


		var renderHits = function renderHits(results) {
			var currentIndex = helper.getIndex();
			renderHandlebarTemplate(results.hits, '#filtered-results-template', $('.collection__product-grid'));
		};

		var getDiscountMessage = function getDiscountMessage($discount_data_container) {
			if ($discount_data_container.length > 0) {
				var discount_vendor = {};
				$discount_data_container.each(function () {
					var discount_type = $(this).data('discountType');
					var discounts = {};
					var product_identifiers = $(this).data('productIdentifiers').split(',');
					discounts["identifiers"] = product_identifiers || ['n/a'];
					discounts["flag"] = $(this).data('flag') || 'n/a';
					discounts["promotionType"] = $(this).data('promotionType') || 'n/a';
					discounts["message"] = $(this).data('discountMessage') || 'n/a';
					discount_vendor[discount_type] = discounts;
				});
				return discount_vendor;
			}
		};

		var renderDiscounts = function renderDiscounts(results, discounts) {
			$.each(discounts, function (i, discountValue) {
				var discountType = discountValue.promotionType;
				$.each(results, function (j, resultValue) {
					if (discountValue.flag == "vendor") {
						$.each(discountValue.identifiers, function (k, identifier) {
							if (discountType == "inclusive") {
								if (resultValue.vendor == identifier) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "exclusive") {
								if (resultValue.vendor != identifier) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "bogo") {
								if (resultValue.vendor == identifier) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else {
								//This is for the other promos
								//IF WE HAD ONE
								//TODO
							}
						});
					} else if (discountValue.flag == "tag") {
						$.each(discountValue.identifiers, function (k, identifier) {
							var index = $.inArray(identifier, resultValue.tags);
							if (discountType == "inclusive") {
								var named_tag_arr = identifier.split(':');
								var $named_tags = resultValue.named_tags[named_tag_arr[0].trim()];
								if ($.isArray($named_tags) ? $.inArray(named_tag_arr[1], $named_tags) : $named_tags == named_tag_arr[1]) {
									resultValue.discount_message = discountValue.message;
									return false;
								}

								if (index != -1) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "exclusive") {
								var named_tag_arr = identifier.split(':');
								var $named_tags = resultValue.named_tags[named_tag_arr[0].trim()];
								if ($.isArray($named_tags) ? !$.inArray(named_tag_arr[1], $named_tags) : $named_tags != named_tag_arr[1]) {
									resultValue.discount_message = discountValue.message;
									return false;
								}

								if (index == -1) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "bogo") {
								if (index != -1) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else {
								//This is for the other promos
								//IF WE HAD ONE
								//TODO
							}
						});
					}
				});
			});
		};

		//trigger for the sort


		var handle = $('.collection').data('collectionId');
		var shop_handle = '';
		var shop_name = window.theme.shop.name.toLowerCase();
		if (shop_name.indexOf('blackwell') >= 0) {
			shop_handle = "Blackwell";
		} else if (shop_name.indexOf('boathouse') >= 0) {
			shop_handle = "Boathouse";
		}$('.filter').on('click', '.facet__menu--showmore', function () {
			showMoreFacets($(this));
		});

		//trigger for collection toggle (mobile)
		$('.collection__filters').on('click', '.collection__filters--toggle', function () {
			$(this).closest('.collection__filters').toggleClass('collection__filters--expanded');
		});

		// Algolia client. Mandatory to instantiate the Helper.
		var algolia = algoliasearch('5IXPKDW7P5', '9994757c959504e41437cea6a891ddd6');

		// Algolia Helper
		var helper = algoliasearchHelper(algolia, 'shopify_products', {
			disjunctiveFacets: ['meta.product.collection_ids', 'named_tags.Website', 'named_tags.Visibility', 'named_tags.Category', 'vendor', 'options.size', 'price_range', 'named_tags.Color', 'named_tags.Availability'],
			hitsPerPage: $('.collection__pagination').data('pagination')
		});

		var windowLocation = window.location.href;
		var url = theme.utils.getURLParams(windowLocation);
		helper.setStateFromQueryString(url);

		// Bind the result event to a function that will update the results
		helper.on("result", searchCallback);

		//facets
		var $facets = $('.filter');
		$facets.on('click', handleFacetClick);

		// Trigger a first search on page load.
		//.toggleRefine('vendor', 'Fox')
		helper.addDisjunctiveFacetRefinement('meta.product.collection_ids', handle);
		helper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
		helper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
		helper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');
		helper.search();Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
			//throw error if wrong number of parameters 
			if (arguments.length < 3) throw new Error("Registered Helper: 'compare' - needs 2 parameters to compare");

			//set operator or default to ==
			var operator = options.hash.operator || "==";
			// list of operators
			var operators = {
				'==': function _(l, r) {
					return l == r;
				},
				'===': function _(l, r) {
					return l === r;
				},
				'!=': function _(l, r) {
					return l != r;
				},
				'<': function _(l, r) {
					return l < r;
				},
				'>': function _(l, r) {
					return l > r;
				},
				'<=': function _(l, r) {
					return l <= r;
				},
				'>=': function _(l, r) {
					return l >= r;
				},
				'typeof': function _typeof(l, r) {
					return (typeof l === 'undefined' ? 'undefined' : _typeof(l)) == r;
				}

				//if no operator is listed in the object over 
			};if (!operators[operator]) throw new Error("Registered Helper: 'compare' - needs a valid operator. Invalide: " + operator);

			//result of compare
			var result = operators[operator](lvalue, rvalue);
			if (result) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		});$('.collection__sort').on('change', '.collection__sort--select', function () {
			var optionSelected = $("option:selected", this).val();
			helper.setIndex(optionSelected);
			$('.collection__sort--select').val($(this).val());
			helper.search();
		});

		//trigger for the pagination page search
		$(document).on('click', '.collection__grid .pagination__link', function () {

			if ($(this).hasClass('pagination__link--active')) {
				return;
			} else {
				var goTo = 0;
				if ($(this).hasClass('pagination__link--prev')) {
					goTo = $(this).data('pagePrev') - 1;
				} else if ($(this).hasClass('pagination__link--next')) {
					goTo = $(this).data('pageNext') + 1;
				} else {
					goTo = $(this).data('pageNumber');
				}
				helper.setPage(goTo).search(); //.addDisjunctiveFacetRefinement('meta.collection.list', handle)
			}

			if ($(this).closest('.collection__pagination--secondary').length > 0) {
				$(window).scrollTop(0);
			}
		});

		//trigger for clear refinements
		$('.filter__facets--clearall').on('click', function () {
			//.toggleRefine('vendor', 'Fox')
			helper.clearRefinements();
			helper.addDisjunctiveFacetRefinement('meta.product.collection_ids', handle);
			helper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
			helper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
			helper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');
			helper.search();
		});

		//trigger view more
		$(document).on('click', '.pagination__view-all', function () {
			//retrieve to know if it is set to pagination or set to
			var paginationHelper;
			if ($('.pagination__view-all span').text().indexOf('All') > -1) {
				paginationHelper = algoliasearchHelper(algolia, 'shopify_products', {
					disjunctiveFacets: ['meta.product.collection_ids', 'named_tags.Website', 'named_tags.Visibility', 'named_tags.Category', 'vendor', 'options.size', 'price_range', 'named_tags.Color', 'named_tags.Availability'],
					hitsPerPage: $('.pagination__view-all').data('itemCount')
				});
			} else {
				paginationHelper = algoliasearchHelper(algolia, 'shopify_products', {
					disjunctiveFacets: ['meta.product.collection_ids', 'named_tags.Website', 'named_tags.Visibility', 'named_tags.Category', 'vendor', 'options.size', 'price_range', 'named_tags.Color', 'named_tags.Availability'],
					hitsPerPage: $('.collection__pagination').data('pagination')
				});
			}

			var windowLocation = window.location.href;
			var url = theme.utils.getURLParams(windowLocation);
			paginationHelper.setStateFromQueryString(url);

			paginationHelper.addDisjunctiveFacetRefinement('meta.product.collection_ids', handle);
			paginationHelper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
			paginationHelper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
			paginationHelper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');

			paginationHelper.search();
			paginationHelper.on('result', searchCallbackWrapper);
		});
	}
});
$(function () {
	$(document).on('click', '.facet__title', function () {
		$(this).closest('.filter__facets').toggleClass('filter__facets--closed');
	});
});
$(function () {
	if (window.theme.template.name == "search") {

		/**
   * showMoreFacets:
   * Hides/Shows more facets
   *
   * @param {Object} $this: object that triggers the expander for show more
   */
		var showMoreFacets = function showMoreFacets($this) {
			$this.parent().toggleClass('facet__menu--expanded');
			$this.children('.showmore').toggleClass('showmore--active');
		};

		//trigger for show more


		// Result event callback
		var searchCallback = function searchCallback(results) {
			var isPagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (results.hits.length === 0) {
				// If there is no result we display a friendly message
				// instead of an empty page.
				$('.collection__product-grid').empty().html("No results");
				$('.collection').addClass('collection__no-results');
				return;
			}

			renderHits(results); //render results
			renderFacets($facets, results); //render facets
			renderPagination(results, isPagination); //render pagination
		};

		// Result event callback for pagination


		var searchCallbackWrapper = function searchCallbackWrapper(results) {
			searchCallback(results, true);
		};

		/**
   * renderPagination:
   * renders the number of pages, arrows, and item count for each search.
   *
   * @param {JSON} results: The full results json returned from algolia
   */


		var renderPagination = function renderPagination(results, isPaginationNotOnLoad) {
			var numResults = results.nbHits,
			    //number of results
			numPages = results.nbPages,
			    //number of pages
			currPage = results.page,
			    //current page
			templateID = '#filtered-results-pagination',
			    //template ID
			$container = $('.collection__pagination');
			var paginationString = "View All";
			if (isPaginationNotOnLoad === true) {
				if ($('.pagination__view-all span').text().indexOf('All') > -1) {
					paginationString = 'View Pagination';
				} else {
					paginationString = 'View All';
				}
			}
			renderHandlebarPagination(templateID, $container, numResults, numPages, currPage, paginationString);
		};

		var naturalSorter = function naturalSorter(as, bs) {
			var a,
			    b,
			    a1,
			    b1,
			    i = 0,
			    n,
			    L,
			    rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
			if (as === bs) return 0;
			a = as.toLowerCase().match(rx);
			b = bs.toLowerCase().match(rx);
			L = a.length;
			while (i < L) {
				if (!b[i]) return 1;
				a1 = a[i], b1 = b[i++];
				if (a1 !== b1) {
					n = a1 - b1;
					if (!isNaN(n)) return n;
					return a1 > b1 ? 1 : -1;
				}
			}
			return b[i] ? -1 : 0;
		};

		var mathSign = function mathSign(x) {
			return parseInt(x / Math.abs(x) || +x);
		};

		/**
   *
   * @param {(Object)}
   * @param {JSON} results
   */


		var renderFacets = function renderFacets($facets, results) {
			results.disjunctiveFacets.map(function (facet) {
				var name = facet.name;
				var facetValues = results.getFacetValues(name, {
					sortBy: ['name:asc']
				});

				//	if(facetValues.every(x => /^\d+:\d+$/.test(x.name))){ //if QA complains comment this line, use line underneath
				if (/^\d+:\d+$/.test(facetValues[0].name)) {
					facetValues.sort(function (a, b) {
						var ka = +a.name.replace(/:.*$/, '');
						var kb = +b.name.replace(/:.*$/, '');
						return mathSign(ka - kb);
					});
				}

				//creates array of facet list items
				var facetsValuesList = $.map(facetValues, function (facetValue) {
					var facetValueClass = facetValue.isRefined ? 'refined' : ''; //add class if refined
					var selected = facetValue.isRefined ? 'checked' : ''; //check checkbox if refined
					var price_regex = /(\d+):(\d+)/; //digit:digit Ex. 25:50
					var unfmtd_price = price_regex.exec(facetValue.name); //execute regex returns array Ex. ['25:50', '25, '50']
					var facetTitle = facetValue.name;

					//if regex returns price range format title properly
					if (unfmtd_price) {
						var left = theme.utils.toMoney(+unfmtd_price[1]); //convert left value to money
						var right = theme.utils.toMoney(+unfmtd_price[2]); //convert right value to money
						facetTitle = left + ' - ' + right;
					}

					//create facet link
					var facetLink = '<a data-attribute="' + name + '" data-value="' + facetValue.name + '" href="#"> <input data-value="' + facetValue.name + '" type="checkbox" ' + selected + ' /> ' + facetTitle + '</a>';
					//return list item
					return '<li class="' + facetValueClass + '">' + facetLink + '</li>';
				});

				//find the correct facet menu
				var $facetsContainer = $facets.find('.filter__facets[data-facet="' + name + '"] .facet__menu');
				//add the list items to menu
				$facetsContainer.html(facetsValuesList.join(''));

				//Add showmore list items only if the number of li in selectElement ul is > 10
				//parent class already on containers that required it
				if ($facetsContainer.find('li').length > 10) {
					$facetsContainer.append('<li class="facet__menu--showmore"><span class="showmore showmore--active">Show more</span><span class="showmore">Show less</span></li>');
				}
			});
		};

		/**
   * This is ugly and should be reverted to how algolia actually worked.
   *
   */


		var createSearchQueryString = function createSearchQueryString() {
			var filters = ['query', 'attribute:*'];
			var queryString = helper.getStateAsQueryString(filters);
			var nextUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?' + queryString;
			var docTitle = document.title;
			window.history.replaceState({}, docTitle, nextUrl);
		};

		/**
   * handleFacetClick:
   * Handles the click even on the targeted facet and does search on attribute for value
   *
   * @param {Event} e
   */


		var handleFacetClick = function handleFacetClick(e) {
			e.preventDefault();
			var target = e.target;
			var attribute = target.dataset.attribute;
			if (!attribute) {
				target = e.target.parentElement;
				attribute = target.dataset.attribute;
			}

			var value = target.dataset.value;
			// Because we are listening in the parent, the user might click where there is no data
			if (!attribute || !value) return;
			// The toggleRefine on facet attribute with value
			helper.toggleRefine(attribute, value).search();
			createSearchQueryString();
		};

		/**
   * Register Helper: Compare
   * - Compares two values (lvalue and rvalue) with given operator.
   * - If no operator direct '=='
   * - Required 2 values else error will be thrown
   */


		/**
   * renderHandlebarPagination:
   * Renders the pagination using handlebars template given all the page details
   *
   * @param {string} templateID: id for handlebars template
   * @param {Object} $renderedContainer: the container where the content is rendered
   * @param {Number} nbHits: Number of hits returned from search results
   * @param {Number} nbPages: Number of pages returned from search results
   * @param {Number} currPage: Current page number
   */
		var renderHandlebarPagination = function renderHandlebarPagination(templateID, $renderedContainer, nbHits, nbPages, currPage, paginationString) {
			var template_source = $(templateID).html(); //get the template

			//create list of pages
			var pages = [];
			for (var i = 0; i < nbPages; i++) {
				var showpage = false;
				if (i == currPage) {
					showpage = true;
				} else if (i + 1 == currPage) {
					showpage = true;
				} else if (i - 1 == currPage) {
					showpage = true;
				} else if (i + 2 == currPage) {
					showpage = true;
				} else if (i - 2 == currPage) {
					showpage = true;
				} else if (currPage < 2 && i < 5) {
					showpage = true;
				}
				if (showpage) {
					pages.push(i + 1);
				} else {
					pages.push(null);
				}
			}
			//create the object needed for handlebars
			var pageinfo = { "hits": nbHits, "current": currPage, "pages": pages, 'maxpages': nbPages - 1, "paginationString": paginationString };

			var template = Handlebars.compile(template_source); //compile the template
			$renderedContainer.html(template(pageinfo)); //render the template
		};

		/**
   * renderHandlebarTeamplate:
   * Renders the hit results using handlebars template given the results.hits json
   *
   * @param {JSON} results: results.hit Json returned from search
   * @param {String} templateID: id for handlebars template
   * @param {Object} $renderedContainer: the container where the content is rendered
   */


		var renderHandlebarTemplate = function renderHandlebarTemplate(results, templateID, $renderedContainer) {
			var template_source = $(templateID).html(); //get template

			var discounts = getDiscountMessage($('.product__identifier-discounts'));
			renderDiscounts(results, discounts);
			/**
    * Register Helper: Currency
    * - Converts amount to currency value.
    */
			Handlebars.registerHelper('currency', function (amount, options) {
				var numericAmount = typeof amount === 'string' ? options.contexts[0].get(amount) : amount;
				var pennies = Math.round(numericAmount * 100);
				var cents = pennies % 100;
				var dollars = Math.round(pennies / 100 - cents / 100);
				var centsStr = '' + cents;
				var result = '$' + dollars + '.' + (centsStr.length < 2 ? '0' + cents : cents);

				return '$' + dollars + '.' + (centsStr.length < 2 ? '0' + cents : cents);
			});

			// $.when.apply($, results.map(function (result) {
			// 	return $.get('/products/'+ result.handle+'.json').then(function (data) {
			// 		if(data.product.images[1] != undefined){
			// 				let temp_hover_img = data.product.images[1].src;
			// 				if(temp_hover_img.indexOf('no-image') < 0){
			// 					//add url to object
			// 					result.hover_image = temp_hover_img;
			// 				}
			// 			}
			// 	}).then($.noop, $.noop);
			// })).then(function () {
			var template = Handlebars.compile(template_source); //compile template
			var wrapper = { products: results }; //create object for handlebars template
			$renderedContainer.html(template(wrapper)); //render template
			//});
		};

		/**
   * renderHits:
   * calls the renderHandlebarTemplate to render all the hit results
   *
   * @param {JSON} results: results returned from the search
   */


		var renderHits = function renderHits(results) {
			//	console.log(results);
			//	var currentIndex = helper.getIndex();
			//	console.log(currentIndex);
			renderHandlebarTemplate(results.hits, '#filtered-results-template', $('.collection__product-grid'));
		};

		var getDiscountMessage = function getDiscountMessage($discount_data_container) {
			if ($discount_data_container.length > 0) {
				var discount_vendor = {};
				$discount_data_container.each(function () {
					var discount_type = $(this).data('discountType');
					var discounts = {};
					var product_identifiers = $(this).data('productIdentifiers').split(',');
					discounts["identifiers"] = product_identifiers || ['n/a'];
					discounts["flag"] = $(this).data('flag') || 'n/a';
					discounts["promotionType"] = $(this).data('promotionType') || 'n/a';
					discounts["message"] = $(this).data('discountMessage') || 'n/a';
					discount_vendor[discount_type] = discounts;
				});
				return discount_vendor;
			}
		};

		var renderDiscounts = function renderDiscounts(results, discounts) {
			$.each(discounts, function (i, discountValue) {
				var discountType = discountValue.promotionType;
				$.each(results, function (j, resultValue) {
					if (discountValue.flag == "vendor") {
						$.each(discountValue.identifiers, function (k, identifier) {
							if (discountType == "inclusive") {
								if (resultValue.vendor == identifier) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "exclusive") {
								if (resultValue.vendor != identifier) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "bogo") {
								if (resultValue.vendor == identifier) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else {
								//This is for the other promos
								//IF WE HAD ONE
								//TODO
							}
						});
					} else if (discountValue.flag == "tag") {
						$.each(discountValue.identifiers, function (k, identifier) {
							var index = $.inArray(identifier, resultValue.tags);
							if (discountType == "inclusive") {
								var named_tag_arr = identifier.split(':');
								var $named_tags = resultValue.named_tags[named_tag_arr[0].trim()];
								if ($.isArray($named_tags) ? $.inArray(named_tag_arr[1], $named_tags) : $named_tags == named_tag_arr[1]) {
									resultValue.discount_message = discountValue.message;
									return false;
								}

								if (index != -1) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "exclusive") {
								var named_tag_arr = identifier.split(':');
								var $named_tags = resultValue.named_tags[named_tag_arr[0].trim()];
								if ($.isArray($named_tags) ? !$.inArray(named_tag_arr[1], $named_tags) : $named_tags != named_tag_arr[1]) {
									resultValue.discount_message = discountValue.message;
									return false;
								}

								if (index == -1) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else if (discountType == "bogo") {
								if (index != -1) {
									resultValue.discount_message = discountValue.message;
									return false;
								}
							} else {
								//This is for the other promos
								//IF WE HAD ONE
								//TODO
							}
						});
					}
				});
			});
		};

		//trigger for the sort


		var shop_handle = '';
		var shop_name = window.theme.shop.name.toLowerCase();
		if (shop_name.indexOf('blackwell') >= 0) {
			shop_handle = "Blackwell";
		} else if (shop_name.indexOf('boathouse') >= 0) {
			shop_handle = "Boathouse";
		}$('.filter').on('click', '.facet__menu--showmore', function () {
			showMoreFacets($(this));
		});

		//trigger for collection toggle (mobile)
		$('.collection__filters').on('click', '.collection__filters--toggle', function () {
			$(this).closest('.collection__filters').toggleClass('collection__filters--expanded');
		});

		// Algolia client. Mandatory to instantiate the Helper.
		var algolia = algoliasearch('5IXPKDW7P5', '9994757c959504e41437cea6a891ddd6');

		// Algolia Helper
		var helper = algoliasearchHelper(algolia, 'shopify_products', {
			disjunctiveFacets: ['named_tags.Category', 'named_tags.Visibility', 'named_tags.Website', 'vendor', 'options.size', 'price_range', 'named_tags.Color', 'named_tags.Availability'],
			hitsPerPage: $('.collection__pagination').data('pagination')
		});

		var windowLocation = window.location.href;
		var url = theme.utils.getURLParams(windowLocation);
		helper.setStateFromQueryString(url);

		// Bind the result event to a function that will update the results
		helper.on("result", searchCallback);

		//facets
		var $facets = $('.filter');
		$facets.on('click', handleFacetClick);

		// Trigger a first search on page load.
		//.toggleRefine('vendor', 'Fox')
		helper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
		helper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
		helper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');
		helper.search();Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
			//throw error if wrong number of parameters
			if (arguments.length < 3) throw new Error("Registered Helper: 'compare' - needs 2 parameters to compare");

			//set operator or default to ==
			var operator = options.hash.operator || "==";
			// list of operators
			var operators = {
				'==': function _(l, r) {
					return l == r;
				},
				'===': function _(l, r) {
					return l === r;
				},
				'!=': function _(l, r) {
					return l != r;
				},
				'<': function _(l, r) {
					return l < r;
				},
				'>': function _(l, r) {
					return l > r;
				},
				'<=': function _(l, r) {
					return l <= r;
				},
				'>=': function _(l, r) {
					return l >= r;
				},
				'typeof': function _typeof(l, r) {
					return (typeof l === 'undefined' ? 'undefined' : _typeof(l)) == r;
				}

				//if no operator is listed in the object over
			};if (!operators[operator]) throw new Error("Registered Helper: 'compare' - needs a valid operator. Invalide: " + operator);

			//result of compare
			var result = operators[operator](lvalue, rvalue);
			if (result) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		});$('.collection__sort').on('change', '.collection__sort--select', function () {
			var optionSelected = $("option:selected", this).val();
			helper.setIndex(optionSelected);
			$('.collection__sort--select').val($(this).val());
			helper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
			helper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
			helper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');
			helper.search();
		});

		//trigger for the pagination page search
		$('.collection__grid').on('click', '.pagination__link', function () {
			if ($(this).hasClass('pagination__link--active')) {
				return;
			} else {
				var goTo = 0;
				if ($(this).hasClass('pagination__link--prev')) {
					goTo = $(this).data('pagePrev') - 1;
				} else if ($(this).hasClass('pagination__link--next')) {
					goTo = $(this).data('pageNext') + 1;
				} else {
					goTo = $(this).data('pageNumber');
				}
				helper.setPage(goTo).search();
			}
		});

		//trigger for clear refinements
		$('.filter__facets--clearall').on('click', function () {
			//.toggleRefine('vendor', 'Fox')
			helper.clearRefinements();
			helper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
			helper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
			helper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');
			helper.search();
		});

		//trigger view more
		$(document).on('click', '.pagination__view-all', function () {
			//retrieve to know if it is set to pagination or set to
			var paginationHelper;
			if ($('.pagination__view-all span').text().indexOf('All') > -1) {
				paginationHelper = algoliasearchHelper(algolia, 'shopify_products', {
					disjunctiveFacets: ['named_tags.Category', 'named_tags.Visibility', 'named_tags.Website', 'vendor', 'options.size', 'price_range', 'named_tags.Color', 'named_tags.Availability'],
					hitsPerPage: $('.pagination__view-all').data('itemCount')
				});
			} else {
				paginationHelper = algoliasearchHelper(algolia, 'shopify_products', {
					disjunctiveFacets: ['named_tags.Category', 'named_tags.Visibility', 'named_tags.Website', 'vendor', 'options.size', 'price_range', 'named_tags.Color', 'named_tags.Availability'],
					hitsPerPage: $('.collection__pagination').data('pagination')
				});
			}

			paginationHelper.addDisjunctiveFacetRefinement('named_tags.Website', shop_handle);
			paginationHelper.addDisjunctiveFacetRefinement('named_tags.Website', 'BOTH');
			paginationHelper.addDisjunctiveFacetRefinement('named_tags.Visibility', 'Y');
			var windowLocation = window.location.href;
			var url = theme.utils.getURLParams(windowLocation);
			paginationHelper.setStateFromQueryString(url);

			paginationHelper.search();
			paginationHelper.on('result', searchCallbackWrapper);
		});
	}
});
$(function () {
	if (window.theme.template.name === "collection" && (window.theme.template.suffix === "brand" || window.theme.template.suffix === "list-collections")) {
		$('.collection__slider-slides').slick({
			slidesToShow: 1,
			autoplay: true,
			autoplaySpeed: 2500,
			slidesToScroll: 1,
			focusOnSelect: false,
			infinite: true,
			dots: false,
			arrows: true,
			draggable: true
		});
	}

	//keeping this for reference for later use
	//this load creates a js object for a secondary image
	// if(window.theme.template.name === "collection"){
	// 	$('.js-utility-div').load(location.href+'?view=images',function(){
	// 		console.log(images);
	// 	});
	// }
});
/*
* Add the product that is currently being viewed to the list of recently viewed products.
* The function takes as input the product that is set as a data attribute on the product page.
*/

var addProduct = function addProduct(productData) {
	var recentlyViewedProducts = localStorage.getItem("recently_viewed");
	var productArray = [];

	if (recentlyViewedProducts) {
		productArray = JSON.parse(recentlyViewedProducts);
		var tail = productArray.length - 1;

		// right now this isn't really necessary
		// if (productArray.length > 15) {
		//     productArray.splice(tail, 1);
		// }

		productArray.forEach(function (product, i, productArray) {
			if (product.id == productData.id) {
				productArray.splice(i, 1);
				--i; //not sure if we need to do this
			}
		});
	}

	/*add the current product to the beginning of the recently view array*/
	productArray.unshift(productData);
	var productArrayAsStr = JSON.stringify(productArray);
	localStorage.setItem("recently_viewed", productArrayAsStr);
};

/** retrieve recently viewed products from local storage and populate product array */
var getProducts = function getProducts() {
	var recentlyViewedProducts = localStorage.getItem("recently_viewed");
	var productArray = [];
	if (recentlyViewedProducts) {
		productArray = JSON.parse(recentlyViewedProducts);
	}
	return productArray;
};

$.fn.getDiscountData = function ($discount_data_container) {
	if ($discount_data_container.length > 0) {
		var discount_vendor = {};
		$discount_data_container.each(function () {
			var discount_type = $(this).data('discountType');
			var discounts = {};
			var product_identifiers = $(this).data('productIdentifiers').split(',');
			discounts["identifiers"] = product_identifiers || ['n/a'];
			discounts["flag"] = $(this).data('flag') || 'n/a';
			discounts["promotionType"] = $(this).data('promotionType') || 'n/a';
			discounts["message"] = $(this).data('discountMessage') || 'n/a';
			discount_vendor[discount_type] = discounts;
		});
		return discount_vendor;
	}
};

$.fn.setDiscounts = function (arrayIndex, discounts) {
	$.each(discounts, function (i, discountValue) {
		var discountType = discountValue.promotionType;
		if (discountValue.flag == "vendor") {
			$.each(discountValue.identifiers, function (k, identifier) {
				if (discountType == "inclusive") {
					if (arrayIndex.vendor == identifier) {
						arrayIndex.discount_message = discountValue.message;
						return false;
					}
				} else if (discountType == "exclusive") {
					if (arrayIndex.vendor != identifier) {
						arrayIndex.discount_message = discountValue.message;
						return false;
					}
				} else if (discountType == "bogo") {
					if (arrayIndex.vendor == identifier) {
						arrayIndex.discount_message = discountValue.message;
						return false;
					}
				} else {
					//This is for the other promos
					//IF WE HAD ONE
					//TODO
				}
			});
		} else if (discountValue.flag == "tag") {
			$.each(discountValue.identifiers, function (k, identifier) {
				var index = $.inArray(identifier, arrayIndex.tags);
				if (discountType == "inclusive") {
					if (index != -1) {
						arrayIndex.discount_message = discountValue.message;
						return false;
					}
				} else if (discountType == "exclusive") {
					if (index == -1) {
						arrayIndex.discount_message = discountValue.message;
						return false;
					}
				} else if (discountType == "bogo") {
					if (index != -1) {
						arrayIndex.discount_message = discountValue.message;
						return false;
					}
				} else {
					//This is for the other promos
					//IF WE HAD ONE
					//TODO
				}
			});
		}
	});
};

//generate the recently view product tiles
$.fn.initiateRecentlyViewed = function (productArray, currentProductId) {
	var count = 0;
	for (var i = 0; i < productArray.length; i++) {
		var product = productArray[i];
		var productPrice = '';
		var productPromoMsg = '';
		var discounts = this.getDiscountData($('.product__identifier-discounts'));

		this.setDiscounts(product, discounts);

		if (product.compare_at_price > product.price) {
			productPrice = '\n                \t<span class="price__compare-at-price">$' + (product.compare_at_price / 100).toFixed(2) + '</span>\n                    <span class="price--special">$' + (product.price / 100).toFixed(2) + '</span>\n                    </div>\n                ';
		} else {
			productPrice = '\n                    <span class="price--original">$' + (product.price / 100).toFixed(2) + '</span>\n                    </div>\n                ';
		}

		if (product.discount_message) {
			productPromoMsg = '<div class="product-tile__image-promo discount-message-colors">' + product.discount_message + '</div>';
		}

		//render recently viewed products - not including current product
		if (product.id != currentProductId) {
			this.append('<div class="product-tile">\n\t\t\t\t<a class="product-tile__image-wrapper" href="/products/' + product.handle + '" title="' + product.title + '">\n\t\t\t\t\t' + productPromoMsg + '\n                    <img class="product-tile__image product-tile__image--hover" src="' + product.image + '" alt="' + product.title + '">\n                    <img class="product-tile__image product-tile__image--alt" src="' + product.altImage + '" alt="' + product.title + '"/>\n                </a>\n                <div class="product-tile__info-section">\n                    <div class="product-tile__brandname">' + product.vendor + '</div>\n                    <a class="product-tile__image-wrapper" href="/products/' + product.handle + '" title="' + product.title + '">\n                        <div class="product-tile__title">' + product.title + '</div>\n                    </a>\n                    <div class="price">' + productPrice + '</div>\n                </div>\n            </div>');

			count++;
		}
		//need to render 6 tiles
		if (count >= 6) break;
	}
};

//be careful about using arrow functions in jquery - may run into scoping issues
$(function () {
	var productInfo = window.currentProductInfo;
	if (productInfo) {
		var id = productInfo.id,
		    title = productInfo.title,
		    handle = productInfo.handle,
		    vendor = productInfo.vendor,
		    price = productInfo.price,
		    compare_at_price = productInfo.compare_at_price,
		    tags = productInfo.tags;

		var recentlyViewedProduct = {};
		if (productInfo.images) {
			var image = productInfo.images[0];
			var altImage = productInfo.images[0];
			if (!!productInfo.images[1]) {
				altImage = productInfo.images[1];
			}

			if (id) {
				recentlyViewedProduct = { id: id, title: title, handle: handle, image: image, altImage: altImage, vendor: vendor, price: price, compare_at_price: compare_at_price, tags: tags };
				addProduct(recentlyViewedProduct);
			}
		}
		var productArray = getProducts();
		if (productArray.length > 1) {
			$('.featured-products__product-tiles').initiateRecentlyViewed(productArray, recentlyViewedProduct.id);
			createCardSlider('.featured-products__product-tiles');
		} else {
			$('.js-recently-viewed').remove();
		}
	}
});

var adjustTileDiscount = function adjustTileDiscount(recommendedTiles, discounts) {
	$.each(discounts, function (i, discountValue) {
		//set discount type
		var discountType = discountValue.promotionType;
		//loop through recommended tile elements
		$.each(recommendedTiles, function (j, tileObj) {
			//if discount flag is vendor then:
			if (discountValue.flag == "vendor") {
				//get vendor value of tile
				var vendor = $(tileObj).data("productVendor");
				//if there's a vendor
				if (vendor) {
					//loop through all identifiers in the discount object
					$.each(discountValue.identifiers, function (k, identifier) {
						//if include and vendor is equal to identifier then add discount to tile
						if (discountType == "inclusive" && vendor == identifier) {
							addDiscountToTile($(tileObj), discountValue.message);
							return false;
							//else if exclusive and vendor not equal to identifier then add discount to tile
						} else if (discountType == "exclusive" && vendor != identifier) {
							addDiscountToTile($(tileObj), discountValue.message);
							return false;
							//else if bogo and vendor equal to identifier then add discount to tile
						} else if (discountType == "bogo" && vendor == identifier) {
							addDiscountToTile($(tileObj), discountValue.message);
							return false;
						} else {
							//This is for the other promos
							//IF WE HAD ONE
							//TODO							
						}
					});
				}
				//else if discount flag is tag then:
			} else if (discountValue.flag == "tag") {
				//set tag list array 
				var tagList = [];
				if ($(tileObj).data("productTags")) {
					tagList = $(tileObj).data("productTags").split(',');
				}
				//if there is a tag list
				if (tagList.length > 0) {
					//loop through discount identifiers
					$.each(discountValue.identifiers, function (k, identifier) {
						var index = $.inArray(identifier, tagList);
						if (discountType == "inclusive" && index != -1) {
							addDiscountToTile($(tileObj), discountValue.message);
							return false;
						} else if (discountType == "exclusive" && index == -1) {
							addDiscountToTile($(tileObj), discountValue.message);
							//set flag here to not trigger the thing again....and...agian...
							return false;
						} else if (discountType == "bogo" && index != -1) {
							addDiscountToTile($(tileObj), discountValue.message);
							return false;
						} else {
							//This is for the other promos
							//IF WE HAD ONE
							//TODO
						}
					});
				}
			}
		});
	});
};

var count = 0;
var addDiscountToTile = function addDiscountToTile($recommendedTile, message) {
	var discountObject = '<div class="product-tile__image-promo discount-message-colors">' + message + '</div>';
	$recommendedTile.find('img.product-tile__image').before(discountObject);
};

var retrieveDiscountData = function retrieveDiscountData($discount_data_container) {
	if ($discount_data_container.length > 0) {
		var discount_vendor = {};
		$discount_data_container.each(function () {
			var discount_type = $(this).data('discountType');
			var discounts = {};
			var product_identifiers = $(this).data('productIdentifiers').split(',');
			discounts["identifiers"] = product_identifiers || ['n/a'];
			discounts["flag"] = $(this).data('flag') || 'n/a';
			discounts["promotionType"] = $(this).data('promotionType') || 'n/a';
			discounts["message"] = $(this).data('discountMessage') || 'n/a';
			discount_vendor[discount_type] = discounts;
		});
		return discount_vendor;
	}
};

//be careful about using arrow functions in jquery - may run into scoping issues
$(function () {
	var recommendedTiles = $('.featured-products__recommended .product-tile');
	var discountObjects = $('.product__identifier-discounts');
	var discountObjList = retrieveDiscountData(discountObjects);
	if (recommendedTiles.length > 0) {
		adjustTileDiscount(recommendedTiles, discountObjList);
	}
});
$(function () {
	$('.footer-list__link.footer-list__link__1').on('click', function (e) {
		e.preventDefault();
		$(this).parent().toggleClass('footer-list__li__1--active');
	});
});

$('.product-tile').on('click', '.product-tile__quickview-link', function (e) {
	e.preventDefault();
	$('.quickview').load($(this).closest('.product-tile').find('.product-tile__quickview-link').data('href'), function () {
		var $image_controller = $(".quickview").find('#image-controller');
		createProductSlider($image_controller, "#image-view");
		$(".product__variants select option:selected, .product__variants input[type=radio]:checked").trigger("change");
		$('.product__form').on('submit', function (e) {
			e.preventDefault();
			var local_storage_id = localStorage.getItem('edit_id');
			if (window.location.href.indexOf('fromCart') > -1) {
				theme.cart.update({ id: local_storage_id, quantity: 0 }).then(function () {
					return addToCart($('.product__form').find('.product__variants'), '.product__variants-option', $('.product__form').find('.product__quantity'));
				});
			} else {
				addToCart($(this).find('.product__variants'), '.product__variants-option', $(this).find('.product__quantity'));
				$(".quickview").removeClass("quickview--active");
			}
		});
	});
	$('.quickview').addClass('quickview--active');
});

$(document).on("click", ".quickview__background", function (e) {
	$(".quickview").removeClass("quickview--active");
});

$(function () {
	if (window.theme.template.name == 'index') {
		$('.homepage__slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			focusOnSelect: false,
			infinite: true,
			dots: true,
			arrows: false,
			draggable: true
		});
	}
});
$(function () {
	$('.account-nav__link').on('click', function () {
		$(this).toggleClass('account-nav__link--active');
	});
});
$(function () {
	$('.addresses__add-new-address').on('click', function (e) {
		e.preventDefault();
		if ($('.addresses__main-container').hasClass('hide-form')) {
			$('.addresses__main-container').removeClass('hide-form');
			$('.addresses__addresses-listing').addClass('hide-listing');
		}
	});
});

// get address id from url params 
$(function () {
	$('.edit-address').first().each(function () {
		var url = window.location.href;
		var urlParams = theme.utils.getURLParams(url);
		var urlAddress = urlParams.address;
		var formAddressId = '#edit_address_' + urlAddress;
		var $formContainer = $('.edit-address').find(formAddressId);
		var addressId = $formContainer.data('addressId');

		if (addressId == urlAddress) {
			$formContainer.addClass("addresses__edit-address-form-container--show");
		}

		history.pushState({}, '', '/account/addresses');
	});
});

$(function () {
	$('.brands__list-container__sublist-title').on('click', function (e) {
		e.preventDefault();
		$(this).parent().find('.brands__list-container__sublist').toggleClass('brands__list-container__sublist--active');
		$(this).toggleClass('brands__list-container__sublist-title--active');
	});
});
$(function () {
	var $tooltip = $('.js-tooltip');
	var $tooltip_open = $('.js-tooltip-open');
	var $tooltip_close = $('.js-tooltip-close');

	// Toggle tooltip
	$tooltip_open.on('click', function (e) {
		$(this).closest($tooltip).toggleClass('is-active');
	});

	$tooltip_close.on('click', function (e) {
		$(this).closest($tooltip).removeClass('is-active');
	});

	// Close tooltip on document click
	$(document).on('click', function (e) {
		if ($(e.target).closest('.js-tooltip').length == 0) {
			$('.js-tooltip').removeClass('is-active');
		}
	});
});
(function (theme, $) {
	theme.loadStoreLabels = function () {
		theme.customer.getPreferredStore().then(function (store) {
			$('[data-store-location]').each(function () {
				var attr = this.dataset.storeLocation;
				var locales = theme.locales;

				switch (attr) {
					case 'directions_url':
						this.href = store.getDirectionsUrl();
						break;
					case 'open':
						this.dataset.storeState = store[attr] == true ? '' + locales.shipment_method.store_state.open : '' + locales.shipment_method.store_state.close;
						this.textContent = store.today_hours ? ' ' + locales.shipment_method.store_state.open_text + ' ' + store.today_hours.open_time : '';
						break;
					case 'open_hours':
						this.innerHTML = store.getHours().reduce(function (html, time) {
							html += '<p class="schedule__time">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="schedule__day" data-store-day="' + time.day + '"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="schedule__hours" data-store-open-time="' + time.open_time + '" data-store-close-time="' + time.close_time + '"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>';
							return html;;
						}, '');
						break;
					case 'address_area':
						this.textContent = store.address_city + ', ' + store.address_province_code + ' ' + store.address_postal_code;
						break;
					default:
						this.textContent = store[attr];
						break;
				}
			});
		});
	};

	$(function () {
		theme.loadStoreLabels();
		$(document).on('store_change', function () {
			theme.loadStoreLabels();
		});
	});
})(window.theme = window.theme || {}, jQuery);

(function (theme, $) {
	var StoreInventory = function () {
		function StoreInventory() {
			_classCallCheck(this, StoreInventory);

			this.states = {
				statusAvailable: 'status--available',
				statusUnavailable: 'status--unavailable'
			};

			this.cache = {};

			this.inventoryParams = [{
				key: 'store_code',
				value: this.getStoreId
			}];
		}

		_createClass(StoreInventory, [{
			key: 'getStoreId',
			value: function getStoreId() {
				return theme.customer.getPreferredStore().then(function (store) {
					return store.store_code;
				});
			}
		}, {
			key: 'loadInventoryData',
			value: function loadInventoryData(url, params) {
				var cacheKey = JSON.stringify(params);
				if (!(cacheKey in this.cache)) {
					this.cache[cacheKey] = $.get(url, params).then(this.parseInventoryData);
				}
				return this.cache[cacheKey];
			}
		}, {
			key: 'parseInventoryData',
			value: function parseInventoryData(data) {
				if ('variants' in data) {
					data = data.variants.reduce(function (inventory, variant) {
						inventory[variant.sku] = variant;
						return inventory;
					}, {});
				}
				return data;
			}
		}, {
			key: 'getInventory',
			value: function getInventory() {
				var _this16 = this;

				return $.when.apply($, this.inventoryParams.map(function (param) {
					return param.value.call(_this16);
				})).then(function () {
					for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
						values[_key] = arguments[_key];
					}

					return values.reduce(function (params, value, index) {
						params[_this16.inventoryParams[index].key] = value;
						return params;
					}, {});
				}).then(function (params) {
					return _this16.loadInventoryData(_this16.endpoint, params);
				});
			}
		}, {
			key: 'getSku',
			value: function getSku(element) {
				return element.dataset.variantSku;
			}
		}, {
			key: 'isAvailable',
			value: function isAvailable(sku) {
				var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

				return this.getInventory().then(function (inventory) {
					return sku in inventory && inventory[sku].quantity >= quantity;
				});
			}
		}, {
			key: 'checkAvailability',
			value: function checkAvailability(variantElement, targetElement, quantity) {
				var _this17 = this;

				return this.isAvailable(this.getSku(variantElement), quantity).done(function (availability) {
					return _this17.setAvailabilityState(targetElement, availability);
				});
			}
		}, {
			key: 'setAvailabilityState',
			value: function setAvailabilityState(element, available) {
				$(element).toggleClass(this.states.statusAvailable, available);
				$(element).toggleClass(this.states.statusUnavailable, !available);
			}
		}]);

		return StoreInventory;
	}();

	var ProductStoreInventory = function (_StoreInventory) {
		_inherits(ProductStoreInventory, _StoreInventory);

		function ProductStoreInventory(productElement) {
			_classCallCheck(this, ProductStoreInventory);

			var _this18 = _possibleConstructorReturn(this, (ProductStoreInventory.__proto__ || Object.getPrototypeOf(ProductStoreInventory)).call(this));

			_this18.productElement = productElement;
			_this18.endpoint = '/apps/integrations-api/v1/product_availability';

			_this18.selectors = {
				productForm: '#product-form-' + _this18.getProductId(),
				variantInput: '[data-variant-sku]',
				availabilityStatus: '.js-product-availability'
			};

			_this18.inventoryParams.push({
				key: 'product_id',
				value: _this18.getProductId
			});

			$(_this18.selectors.productForm).on('change', _this18.selectors.variantInput, function (event) {
				_this18.checkAvailability(event.target, _this18.selectors.availabilityStatus, 1);
			});

			_this18.refreshAvailability();
			return _this18;
		}

		_createClass(ProductStoreInventory, [{
			key: 'refreshAvailability',
			value: function refreshAvailability() {
				var _this19 = this;

				$(this.selectors.productForm).find(this.selectors.variantInput).filter(':checked').get().forEach(function (variantElement) {
					_this19.checkAvailability(variantElement, _this19.selectors.availabilityStatus, 1);
				});
			}
		}, {
			key: 'getProductId',
			value: function getProductId() {
				return this.productElement.dataset.productStoreInventory;
			}
		}]);

		return ProductStoreInventory;
	}(StoreInventory);

	var CartStoreInventory = function (_StoreInventory2) {
		_inherits(CartStoreInventory, _StoreInventory2);

		function CartStoreInventory($container) {
			_classCallCheck(this, CartStoreInventory);

			var _this20 = _possibleConstructorReturn(this, (CartStoreInventory.__proto__ || Object.getPrototypeOf(CartStoreInventory)).call(this));

			_this20.$container = $container;

			_this20.selectors = {
				warnings: '.js-cart-flyout-warning',
				items: '.js-item-pickup-warning',
				notices: '.js-cart-flyout-notice'
			};

			_this20.endpoint = '/apps/integrations-api/v1/item_availability';

			_this20.inventoryParams.push({
				key: 'skus',
				value: _this20.getCartSkus
			});

			_this20.validateInventory();
			return _this20;
		}

		_createClass(CartStoreInventory, [{
			key: 'validateInventory',
			value: function validateInventory() {
				var _this21 = this;

				$.when.apply($, $(this.selectors.items, this.$container).get().map(function (element) {
					return _this21.checkAvailability(element, element, element.dataset.quantity);
				})).then(_asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
					for (var _len2 = arguments.length, availabilities = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
						availabilities[_key2] = arguments[_key2];
					}

					var is_ship_to_store, all_available;
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return theme.customer.isShipToStore();

								case 2:
									is_ship_to_store = _context.sent;
									all_available = availabilities.every(function (availability) {
										return availability;
									});

									_this21.setAvailabilityState($(_this21.selectors.warnings, _this21.$container), all_available || !is_ship_to_store);
									_this21.setAvailabilityState($(_this21.selectors.notices, _this21.$container), all_available && !is_ship_to_store);

								case 6:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this21);
				})));
			}
		}, {
			key: 'getCartSkus',
			value: function getCartSkus() {
				var promise = theme.cart.content.items ? $.when(theme.cart.content) : theme.cart.fetch();
				return promise.then(function (cart) {
					return cart.items.map(function (item) {
						return item.sku;
					});
				});
			}
		}, {
			key: 'getCartQuantities',
			value: function getCartQuantities() {
				var promise = theme.cart.content.items ? $.when(theme.cart.content) : theme.cart.fetch();
				return promise.then(function (cart) {
					return cart.items.reduce(function (quantities, item) {
						quantities[item.sku] = item.quantity + (quantities[item.sku] || 0);
						return quantities;
					}, {});
				});
			}
		}, {
			key: 'checkAvailability',
			value: function checkAvailability(variantElement, targetElement, quantity) {
				var _this22 = this;

				return this.isAvailable(this.getSku(variantElement), quantity).done(function () {
					var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(availability) {
						var is_ship_to_store;
						return _regenerator2.default.wrap(function _callee2$(_context2) {
							while (1) {
								switch (_context2.prev = _context2.next) {
									case 0:
										_context2.next = 2;
										return theme.customer.isShipToStore();

									case 2:
										is_ship_to_store = _context2.sent;

										_this22.setAvailabilityState(targetElement, availability || !is_ship_to_store);

									case 4:
									case 'end':
										return _context2.stop();
								}
							}
						}, _callee2, _this22);
					}));

					return function (_x5) {
						return _ref2.apply(this, arguments);
					};
				}());
			}
		}]);

		return CartStoreInventory;
	}(StoreInventory);

	$(function () {
		var productElement = document.querySelector('[data-product-store-inventory]');
		if (productElement) {
			theme.productStoreInventory = new ProductStoreInventory(productElement);
			$(document).on('store_change', function () {
				theme.productStoreInventory.refreshAvailability();
			});
		}
		theme.cart_inventory = new CartStoreInventory($('.js-cart-item-inventory'));
	});
})(theme = window.theme || {}, jQuery);

(function ($) {
	var storeLocatorForm = document.querySelector('#store-locator-form');
	var store_change_modal_id = 'store_change_modal_id';
	var storeLocator;

	function selectStore(store_code) {
		var previous_store = storeLocator.getSelectedStore();
		if (previous_store) {
			$('#' + previous_store.store_code).removeClass('store--selected');
		}

		var selectedStore = storeLocator.selectStore(store_code);
		if (selectedStore) {
			$('#' + selectedStore.store_code).addClass('store--selected');
		}
	}

	function confirmStoreChange(modal_id) {
		if (theme.cart.content.item_count == 0 || !theme.customer.isShipToStore() || !modal_id) {
			return $.when();
		}

		var promise = $.Deferred();
		var $modal = $('#' + modal_id);

		if ($modal.length > 0) {
			var $confirm = $modal.find('.js-confirm-store-change');
			var modal = new theme.Modal(modal_id);
			modal.show();
			$confirm.off('click').on('click', function () {
				promise.resolve();
				modal.hide();
			});
			$modal.off('modal_hide').on('modal_hide', function () {
				promise.reject();
			});
		}
		return promise.promise();
	}

	if (storeLocatorForm) {
		storeLocator = new theme.StoreLocator(storeLocatorForm);
		window.storeLocator = storeLocator;
		theme.geolocation.getUserLocation().done(function (location) {
			return storeLocator.setLocation(location.latitude, location.longitude);
		}).always(function () {
			$.when(theme.customer.getPreferredStore(), storeLocator.getStores()).then(function (preferredStore) {
				return selectStore(preferredStore.store_code);
			});
		});

		$('.js-showmap-text').removeClass('c-store-locator__showmap__text--show');
		$('.js-showmap').on('click', function () {
			$(this).toggleClass('c-store-locator__showmap--active');
			$('.c-store-locator__map').toggleClass('c-store-locator__map--hide');
			if (!$('.c-store-locator__map').hasClass('c-store-locator__map--hide')) {
				storeLocator.renderMarkers();
			}
		});

		$(document).on('click.store', '.js-show-hours', function () {
			$(this).closest('.store').toggleClass('store--show-hours');
		});

		$(document).on('click.store', '.js-store:not(.store--selected) [data-store-code]', function () {
			$.when(this.dataset.storeCode, confirmStoreChange(store_change_modal_id)).then(function (store_code) {
				theme.customer.setPreferredStore(storeLocator.getStoreByCode(store_code)).then(function (preferredStore) {
					selectStore(preferredStore.store_code);
					storeLocator.updateMapCenter();
					$(document).trigger('store_change');
				});
			});
		});
	}
})(jQuery);

(function (theme, $) {
	/**
  * The ShippingMethodChooser represents a set of
  * buttons that update the ship to store status
  * @class
  */
	var ShippingMethodChooser = function ShippingMethodChooser($container) {
		_classCallCheck(this, ShippingMethodChooser);

		this.elements = {
			$container: $container,
			$selectors: $('.js-update-shipping', $container)
		};

		// Update the shipping method if a selection if made
		this.elements.$selectors.on('click', function (event) {
			var shipping_method = event.currentTarget.dataset.shippingMethod;
			if (shipping_method === theme.customer.constructor.SHIPPING_KEYS.delivery) {
				theme.customer.setPreferredShipping(shipping_method);
				return;
			}

			theme.customer.getPreferredStore().then(function () {
				theme.customer.setPreferredShipping(shipping_method);
			}, function () {
				theme.store_locator_modal.show();
				$(document).one('store_change', function () {
					theme.customer.setPreferredShipping(shipping_method);
				});
			});
		});

		// Update the displayed store
		theme.loadStoreLabels(this.elements.$container);
	};

	theme.ShippingMethodChooser = ShippingMethodChooser;

	$(function () {
		$('.js-shipping-method-selector').each(function (index, element) {
			return new ShippingMethodChooser($(element));
		});
	});
})(window.theme = window.theme || {}, jQuery);
(function (theme, $) {

	var $shipping_inputs = $('[name="shipping-method"]');
	var $shipping = $('[data-shipping]');
	var $show_hours_button = $('[data-show-schedule]');
	var $shipment_submit = $('.js-shipment-confirm');
	var $shipment_alert = $('.js-shipment-alert');
	var $shipment_alert_triggers = $('.js-toggle-alert');

	$show_hours_button.on('click', function () {
		$('[data-scheduled-hours]').toggleClass('shipment__schedule--show');
	});

	$shipment_alert_triggers.on('click', function (e) {
		if ($shipment_submit.hasClass('shipment__submit-button--disabled')) {
			e.preventDefault();
			$shipment_alert.addClass('shipment__alert--active');
		}
	});

	$(document).on('store_change modal_show', function () {
		$('[data-scheduled-hours]').children().length ? $('[data-show-schedule]').removeClass('my-store__hours--hide') : $('[data-show-schedule]').addClass('my-store__hours--hide');
	});

	$shipping_inputs.on('change', function () {

		var id = $(this).attr('id');

		$shipping.removeClass('is-selected');
		$('label[for="' + id + '"]').addClass('is-selected');
		$shipment_submit.removeClass('shipment__submit-button--disabled');
		$shipment_alert.removeClass('shipment__alert--active');
	});

	$(function () {
		$('[data-scheduled-hours]').children().length ? $('[data-show-schedule]').removeClass('my-store__hours--hide') : $('[data-show-schedule]').addClass('my-store__hours--hide');
	});
})(theme = window.theme || {}, jQuery);
}).call(this,require("pBGvAp"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_356bf804.js","/")
},{"babel-runtime/regenerator":1,"buffer":3,"pBGvAp":5}]},{},[8])